<template>
  <div class="machine-user">
    <!-- Hub 头部 + KPI + 分段视图 -->
    <div class="mh-head">
      <h1 class="vtm-page-head__title">{{ $t("machinesHub.title") }}</h1>
      <div class="vtm-page-head__sub">{{ $t("machinesHub.subtitle") }}</div>
    </div>
    <section class="mh-kpis">
      <!-- 点击指标卡：按该状态筛选列表；再点一次（或点总数）取消筛选 -->
      <div :class="{ 'is-active': !statusFilter }" @click="setStatusFilter('')"><stat-card icon="el-icon-cpu" :label="$t('machinesHub.kpiTotal')" :value="kpi.equipmentTotalNum || 0"></stat-card></div>
      <div :class="{ 'is-active': statusFilter === 'online' }" @click="setStatusFilter('online')"><stat-card tone="ok" icon="el-icon-success" :label="$t('machinesHub.kpiOnline')" :value="kpi.equipmentMqYesNum || 0"></stat-card></div>
      <div :class="{ 'is-active': statusFilter === 'offline' }" @click="setStatusFilter('offline')"><stat-card tone="crit" icon="el-icon-remove-outline" :label="$t('machinesHub.kpiOffline')" :value="kpi.equipmentMqNoNum || 0"></stat-card></div>
      <div :class="{ 'is-active': statusFilter === 'attention' }" @click="setStatusFilter('attention')"><stat-card tone="warn" icon="el-icon-bell" :label="$t('machinesHub.kpiFaults')" :value="faultTotal"></stat-card></div>
    </section>
    <!-- 单行工具条：视图切换 + 搜索/操作 + 列设置 -->
    <div class="mh-bar">
      <el-radio-group v-model="view" size="small" class="mh-seg-group">
        <el-radio-button label="list">{{ $t("machinesHub.tabList") }}</el-radio-button>
        <el-radio-button v-if="hubGrants.map" label="map">{{ $t("machinesHub.tabMap") }}</el-radio-button>
        <el-radio-button v-if="hubGrants.groups" label="groups">{{ $t("machinesHub.tabGroups") }}</el-radio-button>
      </el-radio-group>
      <search-user-machine
        v-show="view === 'list'"
        class="mh-search"
        v-on:onSubmit="onSubmit"
        v-on:resetSearch="resetSearch"
        v-on:batchRenewal="batchRenewal"
        v-on:batchManage="batchManage"
        v-on:recoverMachine="recoverMachine"
        @handlerBackAll="handlerBackAll"
        :selectList="selectList"
        :rentStateList="rentStateList"
        :search="search"
        :yesNo="yesNo"
        :isRenewal="isRenewal"
      >
        <template #trail>
          <!-- v4：编号并入机名副行、地址/续费日期默认隐藏 → 新存储键避免旧缓存覆盖新默认 -->
          <column-manager v-if="!isRenewal" :columns="columnConfig" :uid="uId" :storage-key="'machineUserColumns_v4_' + uId" @change="onColumnsChange" />
        </template>
      </search-user-machine>
    </div>

    <div v-show="view === 'list'">
    <div v-if="!isRenewal" class="mh-hint"><i class="el-icon-info"></i> {{ $t("machinesHub.rowHint") }}</div>
    <machine-settings
      :visible.sync="dialogMachineSettings"
      :user-equipment="userEquipment"
      :config-submit="ConfigSubmit"
      :payment="payment"
      :machine-group="machineGroup"
      :yes-no="yesNo"
      :device-mode="modeList"
      :shua-ka-qi="shuaKaQi"
      :coin-acceptor-item="coinAcceptorItem"
      :bill-acceptor-item="billAcceptorItem"
      :age-device="ageDevice"
      :feel-lock="feelLock"
      :age-type="ageType"
      :priority-mode="priorityMode"
      :idcard-country="IdcardCountry"
      @refresh="currentChange(page.pageIndex)"
      @addressUpdated="handleAddressUpdated"
    />
    <edit-user-machine
      :dialogUserMachine="dialogUserMachine"
      :machineGroup="machineGroup"
      :yesNo="yesNo"
      :deviceMode="modeList"
      v-on:cancel="cancel"
      :userEquipment="userEquipment"
    >
    </edit-user-machine>
    <config-user-machine
      :deviceMode="modeList"
      :dialogConfigMachine="dialogConfigMachine"
      :yesNo="yesNo"
      v-on:cancel="configCancel"
      :userEquipment="ConfigSubmit"
      :biaoshi="0"
      :ageDevice="ageDevice"
      :feelLock="feelLock"
      :ageType="ageType"
      :priorityMode="priorityMode"
      :IdcardCountry="IdcardCountry"
    >
    </config-user-machine>
    <user-machine-line-product
      :userEquipment="userEquipment"
      v-on:lineProductCancel="lineProductCancel"
      v-on:changeOpenMode="changeOpenMode"
      :dialogMachineLineProduct="dialogMachineLineProduct"
    >
    </user-machine-line-product>
    <user-machine-maps
      :userEquipment="userEquipment"
      v-on:mapsCancel="mapsCancel"
      v-on:addressUpdated="handleAddressUpdated"
      :dialogMachineMaps="dialogMachineMaps"
    >
    </user-machine-maps>
    <machine-renewal
      :nickName="nickName"
      :renewalList="selectList"
      v-on:cancelRenewal="cancelRenewal"
      :dialogBatchRenewal="dialogBatchRenewal"
    ></machine-renewal>
    <payment
      :payment="payment"
      :yesNo="yesNo"
      :shuaKaQi="shuaKaQi"
      :coinAcceptorItem="coinAcceptorItem"
      :billAcceptorItem="billAcceptorItem"
      v-on:cancelPayment="cancelPayment"
      :dialogPayment="dialogPayment"
    >
    </payment>
    <el-dialog
      :title="$t('inventoryLog.title') + ' - ' + inventoryLogEquipmentNo"
      :visible.sync="dialogInventoryLog"
      width="90%"
      top="5vh"
      append-to-body
      v-dialogDrag
    >
      <inventory-log v-if="dialogInventoryLog" :equipment-no="inventoryLogEquipmentNo"></inventory-log>
    </el-dialog>
    <div class="table vue-padding" ref="tableWrap">
      <el-table
        :key="tableKey"
        ref="machineTable"
        :height="tableHeight"
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :row-class-name="tableRowClassName"
        :data="userMachineList"
        style="width: 100%"
        :border="true"
        row-key="id"
        @sort-change="sortChange"
        @selection-change="handleSelectionChange"
        @row-click="onRowClick"
      >
        <el-table-column :selectable="selectable" type="selection" fixed="left" width="40" :align="'center'"></el-table-column>

        <template v-for="col in visibleColumns">
          <el-table-column
            v-if="col.key === 'equipmentNo'"
            :key="col.key"
            prop="equipmentNo"
            :label="col.label"
            :min-width="col.width"
            :align="'center'"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            v-else-if="col.key === 'locale'"
            :key="col.key"
            prop="locale"
            :label="col.label"
            :min-width="col.width"
            :align="'center'"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.locale">{{ cleanAddress(scope.row.locale) }}</span>
              <el-link v-else type="danger" @click="openAddressDialog(scope.row)"> Click here to Add Address </el-link>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="col.key === 'userName'"
            :key="col.key"
            prop="userName"
            :label="col.label"
            :min-width="col.width"
            :align="'center'"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            v-else-if="col.key === 'teamName'"
            :key="col.key"
            prop="teamName"
            :label="col.label"
            :min-width="col.width"
            :align="'center'"
            sortable="custom"
          >
            <template #default="scope">
              {{ scope.row.userEquipmentTeam && scope.row.userEquipmentTeam.name }}
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="col.key === 'equipmentName'"
            :key="col.key"
            prop="equipmentName"
            :label="col.label"
            :min-width="col.width"
            align="left"
            sortable="custom"
          >
            <template slot-scope="scope">
              <div class="mh-name mh-name--stack">
                <span class="mh-name__text">{{ scope.row.equipmentName || "—" }}</span>
                <span class="mh-name__no vtm-mono">{{ scope.row.equipmentNo }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="col.key === 'wtiSerial'"
            :key="col.key"
            :label="col.label"
            :width="col.width"
            :align="'center'"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.wtiSerialNumber || "—" }}</span>
              <el-button
                type="text"
                size="mini"
                icon="el-icon-edit"
                @click="editWtiSerial(scope.row)"
              ></el-button>
              <el-button
                v-if="isWtiAdmin && scope.row.wtiSerialNumber"
                type="text"
                size="mini"
                :loading="wtiPinging === scope.row.wtiSerialNumber"
                @click="wtiPing(scope.row)"
              >{{ $t("machine.ping") }}</el-button>
              <el-button
                v-if="isWtiAdmin && scope.row.wtiSerialNumber"
                type="text"
                size="mini"
                :loading="wtiRebooting === scope.row.wtiSerialNumber"
                @click="wtiReboot(scope.row)"
              >{{ $t("machine.reboot") }}</el-button>
              <div
                v-if="isWtiAdmin && scope.row.wtiSerialNumber && wtiInfoMap[scope.row.wtiSerialNumber]"
                style="font-size: 12px; color: #909399; line-height: 1.2;"
              >
                {{ wtiInfoMap[scope.row.wtiSerialNumber].description || "—" }}
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-edit"
                  :title="$t('machine.wtiDescription')"
                  @click="editWtiDescription(scope.row)"
                ></el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="col.key === 'simUsage'"
            :key="col.key"
            :label="col.label"
            :width="col.width"
            :align="'center'"
          >
            <template slot-scope="scope">
              <span v-if="!scope.row.wtiSerialNumber">—</span>
              <span v-else-if="wtiInfoMap[scope.row.wtiSerialNumber] === undefined">
                <i class="el-icon-loading"></i>
              </span>
              <span v-else-if="!wtiSims(scope.row).length">—</span>
              <div v-else v-for="sim in wtiSims(scope.row)" :key="sim.number">
                {{ sim.carrier || "SIM" + sim.slot }}: {{ sim.usageMb != null ? sim.usageMb : "—" }} MB
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="col.key === 'simStatus'"
            :key="col.key"
            :label="col.label"
            :width="col.width"
            :align="'center'"
          >
            <template slot-scope="scope">
              <span v-if="!scope.row.wtiSerialNumber">—</span>
              <span v-else-if="wtiInfoMap[scope.row.wtiSerialNumber] === undefined">
                <i class="el-icon-loading"></i>
              </span>
              <template v-else-if="isWtiAdmin">
                <span v-if="!wtiSims(scope.row).length">—</span>
                <div v-else v-for="sim in wtiSims(scope.row)" :key="sim.number" style="white-space: nowrap;">
                  <el-tag
                    :type="sim.status === 'Active' || (sim.esim && sim.inUse) ? 'success' : 'warning'"
                    size="mini"
                  >{{ sim.esim ? "eSIM" : sim.carrier || "SIM" + sim.slot }}: {{ sim.status || (sim.esim ? (sim.inUse ? $t("machine.simInUse") : "—") : "?") }}</el-tag>
                  <template v-if="sim.esim">
                    <el-button
                      type="text"
                      size="mini"
                      style="margin-left: 4px;"
                      @click="wtiEsimAction(scope.row, sim, 'activate')"
                    >{{ $t("machine.simActivate") }}</el-button>
                    <el-button
                      type="text"
                      size="mini"
                      @click="wtiEsimAction(scope.row, sim, 'deactivate')"
                    >{{ $t("machine.simDeactivate") }}</el-button>
                  </template>
                  <el-button
                    v-else
                    type="text"
                    size="mini"
                    style="margin-left: 4px;"
                    @click="wtiSimAction(scope.row, sim)"
                  >{{ sim.status === "Active" ? $t("machine.simDeactivate") : $t("machine.simActivate") }}</el-button>
                </div>
              </template>
              <template v-else>
                <el-tag
                  v-if="wtiInfoMap[scope.row.wtiSerialNumber] && wtiInfoMap[scope.row.wtiSerialNumber].active === true"
                  type="success"
                  size="mini"
                >{{ $t("machine.simActive") }}</el-tag>
                <el-tag
                  v-else-if="wtiInfoMap[scope.row.wtiSerialNumber] && wtiInfoMap[scope.row.wtiSerialNumber].active === false"
                  type="warning"
                  size="mini"
                >{{ $t("machine.simNotActive") }}</el-tag>
                <span v-else>—</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="col.key === 'mqState'"
            :key="col.key"
            prop="mqState"
            :label="col.label"
            :min-width="col.width"
            :align="'center'"
            sortable="mqState"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.mqState == 1">
                <span class="vtm-pill vtm-pill--ok">{{ $t("machineUser.onlinelabel1") }}</span>
              </template>
              <template v-else-if="scope.row.mqState == 0">
                <span class="vtm-pill vtm-pill--crit">{{ $t("machineUser.onlinelabel2") }}</span>
              </template>
              <template v-else-if="!scope.row.mqState">
                <span class="vtm-pill vtm-pill--off">{{ $t("machineUser.onlinelabel3") }}</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="col.key === 'isFaultLock'"
            :key="col.key"
            prop="config.info.isFaultLock"
            :label="col.label"
            :min-width="col.width"
            :align="'center'"
          >
            <template slot-scope="scope">
              <span class="vtm-pill vtm-pill--ok" v-if="scope.row.lockState == 0">{{ $t("operation.normal") }}</span>
              <!-- el-tag 渲染成 span，不在 row-click 的忽略选择器里，同样需要 .stop -->
              <el-tag @click.stop="handleUnlock(scope.row)" type="danger" v-if="scope.row.lockState == 1">{{ $t("operation.unlock") }}</el-tag>
              <span class="vtm-pill vtm-pill--crit" v-if="scope.row.lockState == 2">{{ $t("operation.abnormal") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="col.key === 'faultNum'"
            :key="col.key"
            prop="faultNum"
            :label="col.label"
            :min-width="col.width"
            :align="'center'"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top" :enterable="false">
                <div slot="content">
                  <span style="color:#aaa">&#9632;</span> Fault: {{ scope.row.faultNum }}<br/>
                  <span style="color:#E44D60">&#9632;</span> Out of Stock: {{ scope.row.stockOutNum }}<br/>
                  <span style="color:#F1C901">&#9632;</span> Low in Stock: {{ scope.row.stockAlertNum }}<br/>
                  <span style="color:#09BB07">&#9632;</span> Normal: {{ scope.row.stockNormalNum }}
                </div>
                <div class="track-bar">
                  <div v-if="scope.row.faultNum > 0" class="track-segment track-fault" :style="{ flex: trackFlex(scope.row, 'faultNum') }" @click.stop="changeNowMachineNo(scope.row, scope.$index); colorShow(1)">{{ scope.row.faultNum }}</div>
                  <div v-if="scope.row.stockOutNum > 0" class="track-segment track-out" :style="{ flex: trackFlex(scope.row, 'stockOutNum') }" @click.stop="changeNowMachineNo(scope.row, scope.$index); colorShow(2)">{{ scope.row.stockOutNum }}</div>
                  <div v-if="scope.row.stockAlertNum > 0" class="track-segment track-alert" :style="{ flex: trackFlex(scope.row, 'stockAlertNum') }" @click.stop="changeNowMachineNo(scope.row, scope.$index); colorShow(3)">{{ scope.row.stockAlertNum }}</div>
                  <div v-if="scope.row.stockNormalNum > 0" class="track-segment track-normal" :style="{ flex: trackFlex(scope.row, 'stockNormalNum') }" @click.stop="changeNowMachineNo(scope.row, scope.$index); colorShow(4)">{{ scope.row.stockNormalNum }}</div>
                  <div v-if="!scope.row.faultNum && !scope.row.stockOutNum && !scope.row.stockAlertNum && !scope.row.stockNormalNum" class="track-segment track-empty" style="flex: 1">—</div>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="col.key === 'stripeSubscription'"
            :key="col.key"
            prop="stripeSubscriptionPayType"
            :label="col.label"
            :min-width="col.width"
            :align="'center'"

          >
            <template #default="scope">
              <span v-if="scope.row.expireDate && new Date(scope.row.expireDate) <= new Date()" class="vtm-pill vtm-pill--crit">Expired</span>
              <!-- .stop：否则点击会冒泡到 row-click，订阅弹窗后面又开一个设备详情抽屉 -->
              <div v-else-if="!scope.row.stripeSubscriptionId" class="active-subscription" @click.stop="handleActiveClick(scope.row)">Not subscribed</div>
              <span v-else-if="subscriptionStates[scope.row.equipmentNo] === 'active'" class="vtm-pill vtm-pill--ok">Active</span>
              <span v-else class="vtm-pill vtm-pill--warn">On Trial</span>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="col.key === 'expireDate'"
            :key="col.key"
            prop="expireDate"
            :label="col.label"
            :min-width="col.width"
            :align="'center'"
          >
            <template slot-scope="scope">
              <span :class="scope.row.isOutDate <= 0 ? 'maturity' : ''">{{ isOutDate(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="col.key === 'lastDeliveredTime'"
            :key="col.key"
            prop="lastDeliveredTime"
            :label="col.label"
            :min-width="col.width"
            :align="'center'"
            sortable="custom"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.transactionsLoading" style="color: var(--vtm-mint-ink)">
                <i class="el-icon-loading" style="margin-right: 5px"></i>
                <span style="font-size: 12px">Loading...</span>
              </div>
              <div v-else-if="scope.row.lastDeliveredTime" style="font-size: 12px">{{ formatBackendDateTime(scope.row.lastDeliveredTime) }}</div>
              <span v-else style="color: var(--vtm-ink-2)">No transactions</span>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="col.key === 'enableStatus'"
            :key="col.key"
            prop="enableStatus"
            :label="col.label"
            :formatter="enableStatus"
            :min-width="col.width"
            :align="'center'"
          ></el-table-column>
          <el-table-column
            v-else-if="col.key === 'isDebug'"
            :key="col.key"
            prop="config.manager.isDebug"
            :label="col.label"
            :formatter="isDebug"
            :min-width="col.width"
            :align="'center'"
          ></el-table-column>
          <el-table-column
            v-else-if="col.key === 'isBlue'"
            :key="col.key"
            prop="config.remote.isBlue"
            :label="col.label"
            :formatter="isRemoteControl"
            :min-width="col.width"
            :align="'center'"
          ></el-table-column>
          <el-table-column
            v-else-if="col.key === 'isHaptic'"
            :key="col.key"
            prop="config.remote.isHaptic"
            :label="col.label"
            :formatter="isFeelControl"
            :min-width="col.width"
            :align="'center'"
          ></el-table-column>
          <el-table-column
            v-else-if="col.key === 'isSms'"
            :key="col.key"
            prop="config.info.isSms"
            :label="col.label"
            :formatter="isSms"
            :min-width="col.width"
            :align="'center'"
          ></el-table-column>
        </template>

        <!-- 操作列：一键远程登录 / 货道管理 + 管理入口（打开详情飞出） -->
        <el-table-column :label="$t('common.operate')" width="222" fixed="right" :align="'center'">
          <template slot-scope="scope">
            <!--
              这台机器已经不在当前账号名下（isTransfer=1，即已转给下级账号）：
              只显示「已转移」，不给订阅入口——订阅是机器主人自己的事，
              上级不该替别人的账号激活设备。
            -->
            <span v-if="scope.row.isTransfer !== 0" class="vtm-pill vtm-pill--off">{{ $t("machineUser.transfer") }}</span>
            <template v-else>
              <!--
                自己名下的机器：这个主人还没为它订阅过一次之前，本列只给
                Subscribe to activate。isTransferNew 表示「对这个主人是新机器」——
                转入时置位，订阅后清除。所以新机器被拦住，订了又取消的老客户保留工具，
                换了新主人则重新从闸门开始。
              -->
              <el-link
                v-if="scope.row.isTransferNew == 1 && !scope.row.stripeSubscriptionId && !isWarehouseAccount"
                type="primary"
                icon="el-icon-s-finance"
                @click="subscribeNewDevice(scope.row)"
                style="margin-right: 15px; line-height: 32px"
                >{{ $t("machineUser.subscribeToActivate") }}</el-link
              >
            <div v-else class="mh-quick">
              <el-tooltip :content="$t('machinesHub.remoteLogin')" placement="top" :enterable="false">
                <button
                  type="button"
                  class="mh-quick__btn"
                  :disabled="scope.row.mqState != 1"
                  @click.stop="quickRemote(scope.row)"
                >
                  <i class="el-icon-monitor"></i>
                </button>
              </el-tooltip>
              <el-tooltip :content="$t('machinesHub.manageAisles')" placement="top" :enterable="false">
                <button
                  type="button"
                  class="mh-quick__btn"
                  v-hasPerm="['machine:line:product:update']"
                  @click.stop="machineLineProduct(scope.row)"
                >
                  <i class="el-icon-goods"></i>
                </button>
              </el-tooltip>
              <el-tooltip :content="$t('machinesHub.revenue')" placement="top" :enterable="false">
                <button type="button" class="mh-quick__btn" @click.stop="machineRetainer(scope.row)">
                  <i class="el-icon-money"></i>
                </button>
              </el-tooltip>
              <el-button size="mini" type="primary" plain class="mh-manage" @click.stop="openDetail(scope.row)">
                {{ $t("machinesHub.manage") }}<i class="el-icon-arrow-right el-icon--right"></i>
              </el-button>
            </div>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="userMachineList.length > 0" style="display: flex; align-items: flex-end">
        <el-col :span="16">
          <div class="sekuai_tip" v-if="isFaultNumVisible">
            <span style="color: var(--vtm-crit); font-weight: bolder">{{ $t("machineUser.tishi") }}</span> {{ $t("machineUser.daibiao") }}
            <div class="sekuai">{{ $t("machineUser.guzhang") }}</div>
            <div class="sekuai">{{ $t("machineUser.wuhuo") }}</div>
            <div class="sekuai">{{ $t("machineUser.quehuo") }}</div>
            <div class="sekuai">{{ $t("machineUser.zhengchang") }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <el-pagination
            background
            layout="total,sizes,prev, pager, next,jumper"
            :current-page="page.pageIndex"
            :total="page.totalSize"
            :page-size="page.pageSize"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <!-- 货道新增字段弹窗 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      v-loading="loading"
      :visible.sync="colorDialog"
      :close-on-click-modal="false"
      width="600px"
      custom-class="eCigarette"
      top="6vh"
    >
      <template #title>
        <div style="color: white; font-weight: bolder; display: flex; align-items: center">
          <span
            v-if="colorType == 1"
            class="el-icon-warning"
            style="margin-right: 4px; font-size: 20px; color: #555555"
          ></span>
          <span
            v-if="colorType == 2"
            class="el-icon-warning"
            style="margin-right: 4px; font-size: 20px; color: #e44d60"
          ></span>
          <span
            v-if="colorType == 3"
            class="el-icon-warning"
            style="margin-right: 4px; font-size: 20px; color: #f1c901"
          ></span>
          <span
            v-if="colorType == 4"
            class="el-icon-success"
            style="margin-right: 4px; font-size: 20px; color: #09bb07"
          ></span>
          <div style="position: relative; display: inline-block">
            {{ errorTitle }}
            <div
              v-if="errorData.total > 0 && colorType != 4"
              style="
                font-size: 0.1rem;
                position: absolute;
                background-color: var(--vtm-crit);
                border-radius: 50%;
                top: -10px;
                right: -15px;
                width: 20px;
                height: 20px;
                text-align: center;
                line-height: 20px;
              "
            >
              {{ errorData.total }}
            </div>
          </div>
        </div>
      </template>
      <el-form ref="form" :model="form" label-position="right" label-width="150px">
        <div style="height: 500px; overflow: scroll">
          <div
            style="text-align: center; color: var(--vtm-ink-3); margin-top: 50px"
            v-if="errorData.records && errorData.records.length == 0"
          >
            {{ $t("machineUser.dataEmpty") }}
          </div>
          <el-row
            v-for="(item, index) in errorData.records"
            :key="item.id"
            class="rowClass"
            :style="{
              borderBottom: index + 1 == errorData.records.length ? 'none' : '1px solid var(--vtm-line)'
            }"
          >
            <el-col :span="11">
              <el-form-item :label="$t('machineUser.hd') + item.aisleNo + $t('machineUser.sysps')">
                <el-input
                  style="width: 60px"
                  size="small"
                  @change="handlerChange(item)"
                  v-model="item.currentInventoryLevel"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="13">
              <el-form-item :label="item.goodsName" label-width="100px">
                <div style="display: flex; align-items: center">
                  <img
                    style="height: 40px; width: 40px; margin: 0 30px 0 20px; object-fit: contain"
                    :src="item.url"
                    alt=""
                  />
                  <el-switch
                    @change="handlerChange(item)"
                    v-model="item.faultStatus"
                    :active-value="0"
                    :inactive-value="1"
                  >
                  </el-switch>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 按钮 -->
        <div style="margin-bottom: 20px; display: flex; justify-content: space-around">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page.sync="currentColor"
            :total="+errorData.total"
            :page-size="+errorData.size"
            @current-change="handlerChangeCur"
          ></el-pagination>
        </div>
        <div style="display: flex; justify-content: space-around">
          <div class="btn" @click="handlerOneKey" v-if="this.colorType != 4">
            {{ $t("machineUser.yjcl") }}
          </div>
          <div class="btn" @click="handlerSave">
            {{ $t("helpcenter.confirm") }}
          </div>
        </div>
      </el-form>
    </el-dialog>
    <!-- 留存金 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :visible.sync="retainerVisible"
      :title="$t('machinesHub.takings') + ' —' + retainerTitle"
      v-dialogDrag
      :close-on-click-modal="false"
      width="926px"
      custom-class="eCigarette"
      top="6vh"
    >
      <div v-loading="loadingRetainer" :element-loading-text="$t('common.request')">
        <div class="el-search vue-top-padding" style="padding: 0 0 18px 0; display: flex">
          <div
            style="
              width: 210px;
              height: 120px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #7770fb;
              border-radius: 8px;
              margin-right: 15px;
            "
          >
            <div style="color: white; text-align: center">
              <div style="font-size: 28px">${{ retainerInfo["sales"] }}</div>
              <div>{{ $t("retainer.ljsy") }}</div>
            </div>
          </div>
          <div
            style="
              width: 210px;
              height: 120px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #9570e5;
              border-radius: 8px;
              margin-right: 15px;
            "
          >
            <div style="color: white; text-align: center">
              <div style="font-size: 28px">${{ retainerInfo["cardSales"] }}</div>
              <div>{{ $t("retainer.sksy") }}</div>
            </div>
          </div>
          <div
            style="
              width: 210px;
              height: 120px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #605ff0;
              border-radius: 8px;
              margin-right: 15px;
            "
          >
            <div style="color: white; text-align: center">
              <div style="font-size: 28px">${{ retainerInfo["cashSales"] }}</div>
              <div>{{ $t("retainer.zbsy") }}</div>
            </div>
          </div>
          <div
            style="
              width: 210px;
              height: 120px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #61a5e8;
              border-radius: 8px;
            "
          >
            <div style="color: white; text-align: center">
              <div style="font-size: 28px">${{ retainerInfo["coinSales"] }}</div>
              <div>{{ $t("retainer.tbsy") }}</div>
            </div>
          </div>
        </div>
        <div style="width: 100%">
          <el-table
            :data="retainerData"
            :empty-text="$t('common.noData')"
            :element-loading-text="$t('common.loading')"
            border
            style="width: 100%"
          >
            <el-table-column
              fixed
              prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
              :label="$t('retainer.createTime')"
              align="center"
            ></el-table-column>
            <el-table-column prop="orderNumber" :label="$t('retainer.orderNumber')" align="center"></el-table-column>
            <!-- <el-table-column prop="payType" :label="$t('retainer.payType')" align="center"></el-table-column> -->
            <el-table-column
              prop="payType"
              :label="$t('retainer.payType')"
              :formatter="formatterPayType"
              :align="'center'"
            ></el-table-column>

            <el-table-column prop="payablePrice" :label="$t('retainer.actualPrice')" align="center"></el-table-column>
          </el-table>
          <el-pagination
            v-if="retainerData.length > 0"
            background
            layout="prev, pager, next"
            :current-page="retainerPage.currentPage"
            :total="retainerPage.totalSize"
            :page-size="retainerPage.pageSize"
            @current-change="currentRetainerChange"
          ></el-pagination>
        </div>
        <!-- 操作按钮 -->
        <div
          v-if="retainerData.length > 0"
          style="
            width: 100%;
            display: flow-root;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
          "
        >
          <el-button @click="handlerCleardata" type="primary" size="medium">{{ $t("retainer.cleardata") }}</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="location-dialog"
      :modal-append-to-body="true"
      :append-to-body="true"
      :visible.sync="addressDialogVisible"
      width="750px"
    >
      <span slot="title" class="dialog-title-left">Location Details</span>
      <div class="popup-form">
        <el-form :model="addressForm">
          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Address</el-col>
            <el-col :span="17" class="popup-field">
              <el-autocomplete
                ref="addressAutocomplete"
                v-model="addressForm.location"
                :fetch-suggestions="querySearch"
                placeholder="Enter"
                @select="handleAddressSelect"
                style="width: 100%"
                popper-class="address-suggestion-dropdown"
              >
                <template slot="prefix">
                  <i class="el-icon-search ip-icon" style="margin-right: 4px"></i>
                </template>
                <template slot="suffix">
                  <i
                    v-if="addressForm.location"
                    class="el-icon-close ip-icon"
                    @click="clearAddress"
                    style="cursor: pointer"
                  ></i>
                </template>
                <template slot-scope="{ item }">
                  <div class="address-suggestion-item">
                    <span class="location-icon-bg">
                      <i class="el-icon-location"></i>
                    </span>
                    <div class="suggestion-text">
                      <div class="suggestion-title">{{ item.name }}</div>
                      <div class="suggestion-address">
                        <span v-if="item.county" style="color: var(--vtm-mint-ink); font-weight: 500; margin-right: 6px">{{
                          item.county
                        }}</span>
                        {{ item.address }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-autocomplete>
            </el-col>
          </el-row>

          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Contact Name</el-col>
            <el-col :span="17" class="popup-field">
              <el-input v-model="addressForm.Contact" placeholder="Enter contact name" style="width: 100%"></el-input>
            </el-col>
          </el-row>

          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Phone Number</el-col>
            <el-col :span="17" class="popup-field">
              <el-input
                v-model="addressForm.PhoneNumber"
                placeholder="Enter phone number"
                style="width: 100%"
              ></el-input>
            </el-col>
          </el-row>

          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Email</el-col>
            <el-col :span="17" class="popup-field">
              <el-input v-model="addressForm.email" placeholder="Enter email" style="width: 100%"></el-input>
            </el-col>
          </el-row>

          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Notes</el-col>
            <el-col :span="17" class="popup-field">
              <el-input
                type="textarea"
                v-model="addressForm.Notes"
                placeholder="Enter notes"
                :rows="3"
                style="width: 100%"
              ></el-input>
            </el-col>
          </el-row>

          <el-row class="popup-row">
            <el-col :span="7" class="popup-label" style="margin-top: 10px">Install Date</el-col>
            <el-col :span="17" class="popup-field">
              <el-date-picker
                v-model="addressForm.Installed"
                type="date"
                placeholder="Select install date"
                style="width: 100%"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer-left">
        <el-button type="primary" @click="saveAddress">Save</el-button>
        <el-button @click="addressDialogVisible = false">Cancel</el-button>
      </div>
    </el-dialog>
    </div>
    <!-- 地图视图（原 Remote Login 页并入） -->
    <div v-show="view === 'map'" class="mh-map"><machine-maps v-if="mapMounted" :map-only="true"></machine-maps></div>
    <!-- 分组视图 -->
    <div v-show="view === 'groups'" class="mh-groups"><machine-group v-if="groupsMounted"></machine-group></div>
    <!-- 设备详情飞出：单机全部操作（概览编辑 · 配置 · 支付 · 控制 · 交易） -->
    <machine-detail-flyout
      :visible.sync="detailVisible"
      :machine="activeMachine"
      :config-submit="ConfigSubmit"
      :payment="payment"
      :machine-group="machineGroup"
      :yes-no="yesNo"
      :device-mode="modeList"
      :shua-ka-qi="shuaKaQi"
      :coin-acceptor-item="coinAcceptorItem"
      :bill-acceptor-item="billAcceptorItem"
      :age-device="ageDevice"
      :feel-lock="feelLock"
      :age-type="ageType"
      :priority-mode="priorityMode"
      :idcard-country="IdcardCountry"
      :is-warehouse-account="isWarehouseAccount"
      v-on:saved="currentChange(page.pageIndex)"
      v-on:open-aisles="machineLineProduct"
      v-on:open-inventory="showInventoryLog"
      v-on:open-retainer="machineRetainer"
      v-on:open-oneconfig="handleConfig"
      v-on:open-subscribe="subscribeNewDevice"
      v-on:open-ads="openMachineAds"
    ></machine-detail-flyout>
  </div>
</template>

<script>
  import axios from "@/http/api";
  import { grantedLinks } from "@/utils/navSections";
  import { remoteLogin, cancelRemoteLogin } from "@/utils/remoteLogin";
  import searchUserMachine from "_c/machine/user/SearchUserMachine";
  import columnManager from "_c/machine/user/ColumnManager";
  import machineSettings from "_c/machine/user/MachineSettings";
  import editUserMachine from "_c/machine/user/EditUserMachine";
  import configUserMachine from "_c/machine/user/ConfigUserMachine";
  import userMachineLineProduct from "_c/machine/user/UserMachineLineProduct";
  import inventoryLog from "@/views/machine/user/InventoryLog";
  import userMachineMaps from "_c/machine/user/UserMachineMap";
  import machineRenewal from "_c/machine/user/MachineRenewal";
  import payment from "_c/machine/user/Payment";
  import Clipboard from "clipboard";
  import { Loader } from "@googlemaps/js-api-loader";
  import eventBus from "@/utils/eventBus";
  import StatCard from "_c/common/StatCard.vue";
  import machineDetailFlyout from "_c/machine/user/MachineDetailFlyout";
  import machineMaps from "@/views/machine/user/MachineMaps";
  import machineGroup from "@/views/machine/user/MachineGroup";
  export default {
    name: "MachineUser",
    components: {
      userMachineLineProduct,
      inventoryLog,
      userMachineMaps,
      editUserMachine,
      configUserMachine,
      searchUserMachine,
      machineRenewal,
      payment,
      columnManager,
      machineSettings,
      StatCard,
      machineDetailFlyout,
      machineMaps,
      machineGroup
    },
    data() {
      return {
        // Hub 视图状态
        view: "list",
        mapMounted: false,
        groupsMounted: false,
        kpi: {},
        faultTotal: 0,
        // 指标卡筛选：'' | online | offline | attention（不放进 search，筛选栏重置/提交会整体替换 search）
        statusFilter: "",
        detailVisible: false,
        activeMachine: null,
        subscriptionStates: {},
        addressDialogVisible: false,
        addressForm: {
          name: "",
          location: "",
          lat: "",
          lng: ""
        },
        selectedMachine: null,
        colorDialog: false,
        colorType: "", //当前色块
        nowEquipmentId: "", //当前machineNo
        nowIndex: "", //当前index
        currentColor: 1,
        errorTitle: "",
        errorData: {},
        countError: 0,
        errorChangeArr: [],
        loading: false,
        userMachineList: [],
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        search: {
          equipmentName: "",
          equipmentNo: "",
          userName: "",
          // 一次查多台机器（逗号分隔时由 VtmFilterBar 拆成数组）
          equipmentNoList: [],
          equipmentNameList: [],
          rentState: "",
          faultStatus: "",
          enableStatus: ""
        },
        // For cross-page transaction sorting
        allMachinesSorted: [],
        isSortingAllMachines: false,
        syncingSort: false, //正在同步表头排序箭头，期间忽略 sort-change
        tableHeight: 400, //表格可用高度：整页不滚动，只有列表体滚动
        transactionSortOrder: null, // 'asc' or 'desc'
        originalTotalSize: 0,
        multipleSelection: [],
        yesNo: [],
        ageDevice: [],
        feelLock: [],
        ageType: [],
        priorityMode: [],
        shuaKaQi: [],
        control: {
          remoteCode: "",
          remoteId: "",
          remoteStatus: 0,
          url: ""
        },
        coinAcceptorItem: [],
        billAcceptorItem: [],
        userEquipment: {
          id: "",
          uid: "",
          equipmentNo: "",
          teamId: "",
          equipmentName: "",
          userFinanceId: "",
          userFinanceMachineGroupId: "",
          scene: "",
          servicePhone: "",
          enableStatus: "",
          locale: "",
          notes: "",
          isClose: "",
          isAgeFace: "0",
          modeType: "1",
          lineProductMode: "0",
          vatRate: {
            isSwitch: "0",
            proportion: 0,
            type: "1",
            enableStatus: "1"
          },
          config: {
            age: {}
          },
          lng: "",
          lat: ""
        },
        ConfigSubmit: {
          config: {
            info: {
              isPAd: null,
              isTAd: null,
              isPTag: null,
              isFaultClose: null,
              isCoupon: null,
              isEye: null,
              isPrivacy: null,
              privacy: "",
              isSms: null,
              isFaultLock: null,
              moneySign: "",
              isGoodsMode: null
            },
            manager: {
              isOpen: null,
              isDebug: null,
              passWord: ""
            },

            remote: {
              isBlue: null,
              blueType: null,
              isHaptic: null,
              hapticType: null
            },
            model: {
              type: null,
              lockPage: null,
              isPrompt: null,
              title: "",
              message: "",
              confirm: "",
              cancel: "",
              passWord: "",
              time: []
            },
            vatRate: {
              isOpen: null,
              isCalculating: null,
              type: null,
              proportion: null
            },
            shopping: {
              isTip: null,
              tipTitle: "",
              tipMessage: "",
              tipConfirm: "",
              tipCancel: "",
              isCart: null,
              cartNum: null
            },
            age: {
              isAge: null,
              ageCamera: null,
              ageQrCode: null,
              agePriority: null,
              ageDevice: "",
              isAgeFace: null,
              ageCount: null,
              ageSDK: null,
              faceSimilarity: null,
              isSecurity: null,
              isFace: null,
              time: [],
              ageRange: null
            },
            elock: {
              isOpen: null
            },
            advert: {
              isCountdown: null,
              countdown: ""
            }
          },
          equipmentNo: "",
          id: "",
          verify: [],
          walletPrice: ""
        },
        dialogMachineSettings: false,
        dialogUserMachine: false,
        dialogConfigMachine: false,
        dialogMachineLineProduct: false,
        dialogMachineMaps: false,
        dialogDeposit: false,
        machineGroup: [],
        uId: localStorage.getItem("uId"),
        pId: localStorage.getItem("pId"),
        userDeposit: {
          userName: "",
          nickName: "",
          equipmentNo: "",
          airwayBillNo: ""
        },
        selectList: [],
        dialogBatchRenewal: false,
        dialogManage: false,
        nowRemoteInfo: {},
        nickName: "",
        dialogPayment: false,
        dialogInventoryLog: false,
        inventoryLogEquipmentNo: "",
        payment: {
          equipmentNo: "",
          id: "",
          payConfig: {}
        },
        modeList: [],
        rentStateList: [], //过期筛选
        IdcardCountry: [],
        pzqrcode: "",
        qrloading: false,
        //  留存金
        retainerVisible: false,
        loadingRetainer: false,
        retainerTitle: "",
        retainerPage: {
          pageIndex: 1,
          pageSize: 10,
          totalSize: 0
        },
        retainerSearch: {
          userEquipmentId: 0
        },
        retainerData: [],
        retainerInfo: {
          sales: "0.00",
          cardSales: "0.00",
          cashSales: "0.00",
          coinSales: "0.00"
        },
        payTypeList: [],
        localRetainerId: "",
        isRenewal: false,
        // 主字段前置：机名（含编号副行）/ 在线状态 / 货道库存；地址、编号、续费日期默认隐藏
        // （编号并入机名副行；续费日期移入飞出面板头部；均可经列管理重新显示）
        columnConfig: [
          { key: "equipmentName",     label: this.$t("machineUser.name"),                  visible: true,  width: 230, sortable: "custom" },
          { key: "mqState",           label: this.$t("machineUser.online"),                visible: true,  width: 100, sortable: "mqState" },
          { key: "faultNum",          label: this.$t("machinesHub.aisleStock"),            visible: true,  width: 190 },
          { key: "equipmentNo",       label: this.$t("machineUser.equipmentNo"),          visible: false, width: 140, sortable: "custom" },
          { key: "locale",            label: this.$t("machineUser.address"),               visible: false, width: 250, sortable: "custom" },
          { key: "userName",          label: this.$t("machineUser.userName"),              visible: false, width: 200, sortable: "custom" },
          { key: "teamName",          label: this.$t("machineUser.userMachineGroupName"),  visible: true,  width: 140, sortable: "custom" },
          { key: "isFaultLock",       label: this.$t("editUserMachine.isLock"),            visible: false, width: 190 },
          { key: "stripeSubscription",label: "Subscription Status",                        visible: true,  width: 160 },
          { key: "expireDate",        label: "Renewal Date",                               visible: false, width: 190 },
          { key: "lastDeliveredTime", label: "Last Delivered Transaction",                 visible: true,  width: 240, sortable: "custom" },
          { key: "enableStatus",      label: this.$t("machineUser.enableStatus"),          visible: false, width: 80 },
          { key: "isDebug",           label: this.$t("machineUser.isDebug"),               visible: false, width: 130 },
          { key: "isBlue",            label: this.$t("machineUser.isRemoteControl"),       visible: false, width: 130 },
          { key: "isHaptic",          label: this.$t("machineUser.isFeelControl"),         visible: false, width: 210 },
          { key: "isSms",             label: this.$t("machineUser.isSms"),                 visible: false, width: 100 },
          // WTI columns — admins get per-SIM usage/status + actions; customers get serial + simple status
          { key: "wtiSerial",         label: this.$t("machine.wtiSerial"),                 visible: true,  width: 200 },
          ...(this.$store.state.permissions.includes("*:*:*")
            ? [
                { key: "simUsage",    label: this.$t("machine.simUsage"),                  visible: true,  width: 150 },
                { key: "simStatus",   label: this.$t("machine.simStatus"),                 visible: true,  width: 210 }
              ]
            : [
                { key: "simStatus",   label: this.$t("machine.simStatus"),                 visible: true,  width: 110 }
              ])
        ],
        wtiInfoMap: {},
        wtiPinging: null,
        wtiRebooting: null,
        tableKey: 0,
        isWarehouseAccount: false
      };
    },
    mounted() {
      // 整页不滚动，只有列表体滚动：按表格容器的剩余高度设置 el-table 高度。
      // 容器高度会随筛选栏换行、提示行出现等变化，所以用 ResizeObserver 跟踪。
      this.$nextTick(this.updateTableHeight);
      window.addEventListener("resize", this.updateTableHeight);
      if (typeof ResizeObserver !== "undefined" && this.$refs.tableWrap) {
        this.tableRo = new ResizeObserver(() => this.updateTableHeight());
        this.tableRo.observe(this.$refs.tableWrap);
      }
      this.getIdcardCountry();
      this.getYesNo();
      this.getShuaKaQi();
      this.getCoinAcceptorItem();
      this.getBillAcceptorItem();
      this.listMachineGroup();
      this.listFinance();
      this.getRenewalStatusList();
      this.getAgeDevice();
      this.getFeelLock();
      this.getAgeType();
      this.getPriorityMode();
      this.listPayType();
      this.warehouseAccountList();

      // 处理路由查询参数
      const query = this.$route.query;

      // 加入是从立即续费进来的
      if (query.rentState) {
        this.search.rentState = query.rentState;
        this.isRenewal = true;
      }

      // 处理设备编号搜索
      if (query.equipmentNo) {
        this.search.equipmentNo = query.equipmentNo;
      }

      // 执行搜索
      this.currentChange();
      // Hub KPI
      this.loadKpis();

      // Listen for address updates from Location.vue
      eventBus.on("machineAddressUpdated", this.handleAddressUpdatedFromLocation);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.updateTableHeight);
      if (this.tableRo) {
        this.tableRo.disconnect();
        this.tableRo = null;
      }
      // Clean up event listener
      eventBus.off("machineAddressUpdated", this.handleAddressUpdatedFromLocation);
      // 停止任何进行中的远程登录轮询，避免离开页面后弹窗/打开远程桌面
      cancelRemoteLogin(this);
    },
    watch: {
      // 懒挂载地图/分组视图（首次切换时才初始化）
      view(v) {
        if (v === "map") {
          this.mapMounted = true;
        }
        if (v === "groups") {
          this.groupsMounted = true;
        }
      }
    },
    computed: {
      // 各分段对应的旧页面授权（子账号可能仅被授予部分页面）
      hubGrants() {
        const g = grantedLinks(this.$store.state.menuList);
        return {
          map: g.has("/machine/user/machine-maps") || g.has("/machine/user/location"),
          groups: g.has("/machine/user/machine-group")
        };
      },
      isWtiAdmin() {
        return this.$store.state.permissions.includes("*:*:*");
      },
      visibleColumns() {
        return this.columnConfig.filter(c => c.visible);
      },
      isFaultNumVisible() {
        const col = this.columnConfig.find(c => c.key === 'faultNum');
        return col && col.visible;
      },
    },
    methods: {
      // Hub KPI（在线/离线/总数 + 故障）
      loadKpis() {
        this.$api
          .request(this.$url.Consoles.getMachine, this.$method.get, {})
          .then(res => {
            if (res.code === 0 && res.data) {
              this.kpi = res.data;
            }
          })
          .catch(() => {});
        // “需要处理”卡显示机器台数，用和点击后列表相同的查询（attention=1），数字与列表一致
        // （以前是故障+库存提醒条数：一台机器 8 条提醒，卡片显示 8，列表只有 1 台）
        this.$api
          .request(this.$url.UserMachine.page, this.$method.get, { attention: 1, pageIndex: 1, pageSize: 1 })
          .then(res => {
            if (res.code === 0 && res.data) {
              this.faultTotal = Number(res.data.total) || 0;
            }
          })
          .catch(() => {});
      },
      // 行点击 → 详情飞出（忽略操作按钮/复选框/链接上的点击）
      onRowClick(row, column, event) {
        if (event && event.target && event.target.closest && event.target.closest("button, a, .el-checkbox, .el-link, .el-popover, input")) {
          return;
        }
        this.openDetail(row);
      },
      openDetail(row) {
        this.syncDetail(row);
        this.detailVisible = true;
      },
      // 用行数据重建详情飞出里的配置/支付对象。列表刷新后也要调用：否则面板里还是打开时的旧配置，
      // 切换标签或保存广告设置时会把旧值写回（如购物车开关被还原）
      syncDetail(row) {
        // 构建内嵌配置/支付所需的数据对象（沿用 openSettings 的构造，不再打开旧弹窗）
        this.userEquipment = JSON.parse(JSON.stringify(row));
        this.userEquipment.id = row.id;
        this.payment = {
          equipmentNo: row.equipmentNo,
          id: row.id,
          payConfig: row.payConfig ? JSON.parse(JSON.stringify(row.payConfig)) : {}
        };
        this.ConfigSubmit.config = row.config ? JSON.parse(JSON.stringify(row.config)) : {};
        this.ConfigSubmit.equipmentNo = row.equipmentNo;
        this.ConfigSubmit.id = row.id;
        this.ConfigSubmit.verify = row.verify ? JSON.parse(JSON.stringify(row.verify)) : [];
        this.ConfigSubmit.walletPrice = row.walletPrice;
        this.$set(this.ConfigSubmit, "mqState", row.mqState);
        this.activeMachine = row;
      },
      //方便仓库同事配置设备
      warehouseAccountList() {
        this.$api.dict("warehouse_account").then(res => {
          if (res.code === 0) {
            let warehouseAccount = localStorage.getItem("warehouseAccount");
            this.isWarehouseAccount = res.data.some(item => item.value === warehouseAccount);
          }
        });
      }, // 处理Active点击事件
      handleActiveClick(row) {
        this.selectList = [row];
        this.nickName = row.nickName || '';
        this.dialogBatchRenewal = true;
      },
      //留存金
      // 查看该设备的库存变更日志
      showInventoryLog(row) {
        this.inventoryLogEquipmentNo = row.equipmentNo;
        this.dialogInventoryLog = true;
      },
      machineRetainer(row) {
        let _self = this;
        _self.retainerTitle = " " + row.equipmentNo;
        _self.retainerVisible = true;
        _self.localRetainerId = row.id;
        _self.currentRetainerChange(1, row.id);
      },
      // 表格高度 = 容器可用高度 - 分页行，保证分页始终可见且整页不出现第二个滚动条
      updateTableHeight() {
        const wrap = this.$refs.tableWrap;
        if (!wrap) {
          return;
        }
        const shell = document.querySelector(".vtm-shell__panel");
        const bottom = shell ? shell.getBoundingClientRect().bottom : window.innerHeight;
        const visible = bottom - wrap.getBoundingClientRect().top;
        // BigScreen 把整个应用按 1920 设计宽缩放：getBoundingClientRect 拿到的是缩放后的
        // 视觉像素，而 el-table 的 height 是缩放前的设计像素，必须先还原
        const screen = document.querySelector(".big-screen");
        const scale = screen && screen.clientWidth ? screen.clientWidth / 1920 : 1;
        const reservedForPager = 56;
        const h = Math.floor(visible / (scale || 1)) - reservedForPager;
        this.tableHeight = Math.max(240, h);
      },
      async sortChange(column) {
        // 程序化同步表头箭头时不重复发请求（数据已由 onSubmit 拉取）
        if (this.syncingSort) {
          return;
        }
        // Handle cross-page sorting for lastDeliveredTime
        if (column.prop === "lastDeliveredTime") {
          if (!column.order) {
            // Clear sorting
            this.transactionSortOrder = null;
            this.isSortingAllMachines = false;
            this.allMachinesSorted = [];
            this.page.pageIndex = 1;
            this.currentChange();
            return;
          }

          this.transactionSortOrder = column.order === "ascending" ? "asc" : "desc";
          await this.sortAllMachinesByTransaction();
          return;
        }

        // Handle sorting for all other columns (backend sorting)
        // Clear transaction sorting when switching to other columns
        this.transactionSortOrder = null;
        this.isSortingAllMachines = false;
        this.allMachinesSorted = [];

        if (column.order === "ascending") {
          this.search.order = "asc";
          this.search.sort = column.prop;
        } else if (column.order === "descending") {
          this.search.order = "desc";
          this.search.sort = column.prop;
        } else {
          delete this.search.sort;
          delete this.search.order;
        }
        this.page.pageIndex = 1;
        this.currentChange();
      },
      onColumnsChange(cols) {
        this.columnConfig = cols;
        this.tableKey++;
      },
      handlerBackAll() {
        this.isRenewal = false;
        this.search.rentState = "";
        this.currentChange();
      },
      // 点击色块
      trackFlex(row, key) {
        const fault = parseInt(row.faultNum) || 0;
        const stockOut = parseInt(row.stockOutNum) || 0;
        const stockAlert = parseInt(row.stockAlertNum) || 0;
        const stockNormal = parseInt(row.stockNormalNum) || 0;
        const total = fault + stockOut + stockAlert + stockNormal;
        if (total === 0) return 1;
        const val = parseInt(row[key]) || 0;
        // Give each non-zero segment a minimum baseline of 10% of total to stay visible
        const baseline = total * 0.1;
        return Math.max(val, baseline);
      },
      colorShow(n) {
        // this.currentChange = 1;
        this.currentColor = 1;
        this.colorDialog = true;
        this.colorType = n;
        switch (n) {
          case 1:
            this.errorTitle = this.$t("machineUser.hdgzxq");
            break;
          case 2:
            this.errorTitle = this.$t("machineUser.hdjgxq");
            break;
          case 3:
            this.errorTitle = this.$t("machineUser.hdqhxq");
            break;
          case 4:
            this.errorTitle = this.$t("machineUser.zchdxq");
            break;
        }
      },
      changeNowMachineNo(row, index) {
        this.nowEquipmentId = row.id;
        this.nowIndex = index;
        // console.log(this.nowMachineNo);
        this.getColorData();
      },
      // 数据修改
      handlerChange(item) {
        if (+item.currentInventoryLevel > item.maxAllowedStock) {
          item.currentInventoryLevel = item.maxAllowedStock;
          this.$message.warning(this.$t("machineUser.szcgmax"));
          return;
        }
        // 修改后的对象装进提交数组
        let isHas = false; //查重
        this.errorChangeArr.forEach(ite => {
          if (ite.id == item.id) {
            //重复
            ite.faultStatus = item.faultStatus;
            ite.currentInventoryLevel = item.currentInventoryLevel;
            isHas = true;
          }
        });
        if (!isHas) {
          //无重复
          let obj = {
            id: item.id,
            faultStatus: item.faultStatus,
            currentInventoryLevel: item.currentInventoryLevel
          };
          this.errorChangeArr.push(obj);
        }
      },
      //一键处理
      handlerOneKey() {
        let that = this;
        let nums = "";
        this.errorData.records.forEach(item => {
          nums = nums + item.aisleNo + ",";
        });
        nums = nums.slice(0, -1);
        if (that.colorType == 1) {
          this.$confirm(
            this.$t("machineUser.cczjhkq") + nums + this.$t("machineUser.jzd1"),
            this.$t("machineUser.sfyjcl"),
            {
              confirmButtonText: this.$t("common.definite"),
              cancelButtonText: this.$t("common.cancel")
            }
          ).then(() => {
            that.errorData.records.forEach(item => {
              item.faultStatus = 0;
            });
            that.handlerSave(1);
          });
        } else {
          this.$confirm(
            this.$t("machineUser.bm1") + nums + this.$t("machineUser.jzd2"),
            this.$t("machineUser.sfyjbm"),
            {
              confirmButtonText: this.$t("common.definite"),
              cancelButtonText: this.$t("common.cancel")
            }
          ).then(() => {
            that.errorData.records.forEach(item => {
              item.currentInventoryLevel = item.maxAllowedStock;
            });
            that.handlerSave(1);
          });
        }
      },
      // 获取色块数目 修改的列表接口
      getColorNum() {
        this.loading = true;
        let obj = {
          equipmentId: this.nowEquipmentId
        };
        this.$api.request(this.$url.UserMachine.page, this.$method.get, obj).then(res => {
          if (res.code === 0) {
            // 本项就是更改了的那个 只需要拿里面的颜色数据即可
            this.userMachineList.splice(this.nowIndex, 1, res.data.records[0]);
            // 色块大小
            let faultNum = res.data.records[0]["faultNum"] ? parseInt(res.data.records[0]["faultNum"]) : 0;
            let stockOutNum = res.data.records[0]["stockOutNum"] ? parseInt(res.data.records[0]["stockOutNum"]) : 0;
            let stockAlertNum = res.data.records[0]["stockAlertNum"]
              ? parseInt(res.data.records[0]["stockAlertNum"])
              : 0;
            let stockNormalNum = res.data.records[0]["stockNormalNum"]
              ? parseInt(res.data.records[0]["stockNormalNum"])
              : 0;
            // 2.求分母
            let total = faultNum + stockOutNum + stockAlertNum + stockNormalNum;
            // 3.定义总宽度
            let totalwidth = 200;

            // 新的划分方式 修改逻辑
            //  -1 全部赋值1/10 如果>0存在的话
            let all = 10;
            let faultNum1 = 0;
            //  -2保证每一个只要存在就占比1/10
            if (faultNum > 0) {
              // 如果存在至少占0.25百分比
              faultNum1++;
              all--;
            }

            let stockOutNum1 = 0;
            if (stockOutNum > 0) {
              // 如果存在至少占0.25百分比
              stockOutNum1++;
              all--;
            }

            let stockAlertNum1 = 0;
            if (stockAlertNum > 0) {
              // 如果存在至少占0.25百分比
              stockAlertNum1++;
              all--;
            }

            let stockNormalNum1 = 0;
            if (stockNormalNum > 0) {
              // 如果存在至少占0.25百分比
              stockNormalNum1++;
              all--;
            }
            // 此时all为十份中的剩余
            if (total == 0) {
              // 总数为0 均分格子都为
              faultNum1 = 2.5;
              stockOutNum1 = 2.5;
              stockAlertNum1 = 2.5;
              stockNormalNum1 = 2.5;
            } else {
              // 剩下的色块分
              faultNum1 = faultNum1 + faultNum / all;
              stockOutNum1 = stockOutNum1 + stockOutNum / all;
              stockAlertNum1 = stockAlertNum1 + stockAlertNum / all;
              stockNormalNum1 = stockNormalNum1 + stockNormalNum / all;
            }
            res.data.records[0]["faultNumWidth"] = totalwidth * faultNum1;
            res.data.records[0]["stockOutNumWidth"] = totalwidth * stockOutNum1;
            res.data.records[0]["stockAlertNumWidth"] = totalwidth * stockAlertNum1;
            res.data.records[0]["stockNormalNumWidth"] = totalwidth * stockNormalNum1;
          }
          this.loading = false;
        });
      },
      // 确认保存
      handlerSave(oneKey = 0) {
        if (this.errorChangeArr.length <= 0 && oneKey != 1) {
          this.colorDialog = false;
          return;
        }
        this.loading = true;
        let tempData = [];
        if (oneKey == 1) {
          tempData = this.errorData.records;
        } else {
          tempData = this.errorChangeArr;
        }
        axios({
          url: this.$url.UserMachine.saveError,
          method: this.$method.put,
          headers: {
            "Content-Type": "application/json"
          },
          data: JSON.stringify(tempData)
        }).then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.errorChangeArr = []; //成功后清除修改数组
            this.$message.success(res.msg);
            if (oneKey != 1) {
              //确认保存
              this.colorDialog = false;
            } else {
              this.handlerFirstCur();
            }
            // 此处确认保存已经成功 前端改变色块区域
            this.getColorNum();
          } else {
            this.$message.warning(res.msg);
          }
        });
      },
      // 首页
      handlerFirstCur() {
        this.currentColor = 1;
        this.getColorData();
      },
      // 跳页
      handlerChangeCur(e) {
        this.currentColor = e;
        this.getColorData();
      },
      getColorData() {
        this.loading = true;
        this.$api
          .request(this.$url.UserMachine.errorLook, this.$method.get, {
            equipmentId: this.nowEquipmentId,
            searchType: this.colorType,
            pageIndex: this.currentColor
          })
          .then(res => {
            this.errorData = res.data;
            this.loading = false;
          });
      },
      handlerCleardata() {
        let _self = this;
        _self
          .$confirm(_self.$t("retainer.cleardatatips"), _self.$t("common.warning"), {
            confirmButtonText: _self.$t("common.definite"),
            cancelButtonText: _self.$t("common.cancel"),
            type: "warning"
          })
          .then(() => {
            _self.$api
              .request(_self.$url.UserMachine.payRecordClear, _self.$method.post, {
                userEquipmentId: _self.localRetainerId
              })
              .then(res => {
                _self.$notify({
                  title: this.$t("common.tip"),
                  message: res.msg,
                  type: "success"
                });
                _self.currentRetainerChange(1, _self.localRetainerId);
              })
              .catch(res => {
                _self.$notify({
                  title: this.$t("common.tip"),
                  message: res.msg,
                  type: "warning"
                });
              });
          });
      },
      listPayType() {
        let _self = this;
        _self.$api.dict("gp_pay_type").then(res => {
          if (res.code === 0) {
            _self.payTypeList = res.data;
          }
        });
      },
      currentRetainerChange(pageIndex, id) {
        let _self = this;
        _self.loadingRetainer = true;
        _self.retainerPage.pageIndex = pageIndex ? pageIndex : 1;
        if (id) {
          _self.retainerSearch.userEquipmentId = id;
        }
        let obj = _self.$cloud.objMerge(_self.retainerSearch, _self.retainerPage);
        _self.$api
          .request(_self.$url.UserMachine.payRecord, _self.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              _self.retainerData = res.data.records;
              _self.retainerPage.totalSize = parseInt(res.data.total);
              if (res.data.sum) {
                _self.retainerInfo = res.data.sum;
              } else {
                _self.retainerInfo = {
                  sales: "0.00",
                  cardSales: "0.00",
                  cashSales: "0.00",
                  coinSales: "0.00"
                };
              }
            }
            _self.loadingRetainer = false;
          })
          .catch(() => {
            _self.loadingRetainer = false;
          });
      },
      // 回收设备
      recoverMachine() {
        this.$confirm(this.$t("machine.recycle"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.Machine.userRecover, this.$method.put, {
              equipmentIds: this.$cloud.getIds(this.selectList)
            })
            .then(res => {
              // console.log(res);
              let obj = JSON.parse(res.data);
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  dangerouslyUseHTMLString: true,
                  message: `number of successes:${obj.success}<br/>number of failures:${obj.error}<br/>${res.msg}`,
                  type: "success"
                });
                this.currentChange();
              }
            });
        });
      },
      // 解锁
      handleUnlock(row) {
        this.$confirm(this.$t("common.gzsptip"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            this.loading = true;
            this.$api
              .request(this.$url.UserMachine.update, this.$method.put, {
                teamId: row.teamId,
                id: row.id,
                isLock: 0
              })
              .then(res => {
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: this.$t("common.unlockcg"),
                    type: "success"
                  });
                }
                this.loading = false;
                this.pageIndex = 1;
                this.currentChange();
              })
              .catch(() => {
                this.loading = false;
              });
          })
          .catch(() => {});
      },
      // 一键配置同款
      handleConfig(row) {
        this.$confirm(this.$t("machineUser.warnConfig"), this.$t("common.warning"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            this.$api
              .request(this.$url.UserMachine.config, this.$method.post, {
                id: row.id
              })
              .then(res => {
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg,
                    type: "success"
                  });
                  this.currentChange();
                } else {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg,
                    type: "error"
                  });
                }
              });
          })
          .catch(res => {
            // console.log(res);
          });
      },
      tableRowClassName({ row }) {
        if (row.enableStatus == 0) {
          return "warning-row";
        }
      },
      // 一键远程登录（仅在线设备可用）
      quickRemote(row) {
        if (row.mqState != 1) {
          return;
        }
        remoteLogin(this, row);
      },
      handleSelectionChange(val) {
        this.selectList = val;
      },
      listFinance() {
        this.$api.dict("gp_user_machine_mode").then(res => {
          this.modeList = res.data;
        });
      },
      getIdcardCountry() {
        this.$api.dict("sys_idcard_country").then(res => {
          if (res.code === 0) {
            this.IdcardCountry = res.data;
          }
        });
      },
      getRenewalStatusList() {
        this.$api.dict("renewal_status").then(res => {
          if (res.code === 0) {
            this.rentStateList = res.data;
          }
        });
      },
      getYesNo() {
        this.$api.dict("sys_yes_no").then(res => {
          if (res.code === 0) {
            this.yesNo = res.data;
          }
        });
      },
      getAgeDevice() {
        this.$api.dict("age_device").then(res => {
          if (res.code === 0) {
            this.ageDevice = res.data;
          }
        });
      },
      getFeelLock() {
        this.$api.dict("feel_lock").then(res => {
          if (res.code === 0) {
            this.feelLock = res.data;
          }
        });
      },
      getAgeType() {
        this.$api.dict("age_discern_type").then(res => {
          if (res.code === 0) {
            this.ageType = res.data;
          }
        });
      },
      getPriorityMode() {
        this.$api.dict("priority_mode").then(res => {
          if (res.code === 0) {
            this.priorityMode = res.data;
          }
        });
      },
      getShuaKaQi() {
        this.$api.dict("sys_shua_kaqi").then(res => {
          if (res.code === 0) {
            this.shuaKaQi = res.data;
          }
        });
      },
      getCoinAcceptorItem() {
        this.$api.dict("coin_acceptor").then(res => {
          if (res.code === 0) {
            this.coinAcceptorItem = res.data;
          }
        });
      },
      getBillAcceptorItem() {
        this.$api.dict("bill_acceptor").then(res => {
          if (res.code === 0) {
            this.billAcceptorItem = res.data;
          }
        });
      },
      listMachineGroup() {
        this.$api.request(this.$url.UserMachineGroup.list, this.$method.get).then(res => {
          if (res.code === 0) {
            this.machineGroup = res.data;
          }
        });
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      wtiSims(row) {
        const info = this.wtiInfoMap[row.wtiSerialNumber];
        return (info && info.sims) || [];
      },
      wtiPing(row) {
        const sn = row.wtiSerialNumber;
        this.wtiPinging = sn;
        this.$api
          .request(this.$url.Machine.wtiPing, this.$method.get, { sn: sn })
          .then(res => {
            this.wtiPinging = null;
            if (res.code === 0 && res.data && res.data.length) {
              const esc = s => String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
              this.$alert(res.data.map(esc).join("<br>"), `Ping ${sn}`, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t("common.definite")
              });
            } else {
              this.$message.error(res.msg || this.$t("machine.pingFailed"));
            }
          })
          .catch(() => {
            this.wtiPinging = null;
            this.$message.error(this.$t("machine.pingFailed"));
          });
      },
      wtiReboot(row) {
        const sn = row.wtiSerialNumber;
        this.$confirm(
          this.$t("machine.rebootConfirm", { sn: sn, name: row.equipmentName || row.equipmentNo }),
          this.$t("common.tip"),
          {
            confirmButtonText: this.$t("common.definite"),
            cancelButtonText: this.$t("common.cancel"),
            type: "warning"
          }
        ).then(() => {
          this.wtiRebooting = sn;
          this.$api
            .request(this.$url.Machine.wtiReboot, this.$method.post, { sn: sn })
            .then(res => {
              this.wtiRebooting = null;
              if (res.code === 0) {
                this.$message.success(this.$t("machine.rebootQueued"));
              } else {
                this.$message.error(res.msg || this.$t("machine.rebootFailed"));
              }
            })
            .catch(() => {
              this.wtiRebooting = null;
              this.$message.error(this.$t("machine.rebootFailed"));
            });
        }).catch(() => {});
      },
      editWtiDescription(row) {
        const sn = row.wtiSerialNumber;
        const info = this.wtiInfoMap[sn];
        this.$prompt(this.$t("machine.wtiDescriptionTip"), this.$t("machine.wtiDescription"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          inputValue: (info && info.description) || ""
        }).then(({ value }) => {
          const description = (value || "").trim();
          this.$api
            .request(this.$url.Machine.wtiDescription, this.$method.put, { sn: sn, description: description })
            .then(res => {
              if (res.code === 0) {
                if (info) {
                  this.$set(info, "description", description);
                }
                this.$message.success(this.$t("common.success"));
              } else {
                this.$message.error(res.msg || this.$t("machine.wtiDescriptionFailed"));
              }
            });
        }).catch(() => {});
      },
      wtiSimAction(row, sim) {
        const action = sim.status === "Active" ? "deactivate" : "activate";
        const label = action === "deactivate" ? this.$t("machine.simDeactivate") : this.$t("machine.simActivate");
        this.$confirm(
          `${label} ${sim.carrier || "SIM" + sim.slot} (${sim.number}) — ${row.equipmentName || row.equipmentNo}?`,
          this.$t("common.tip"),
          {
            confirmButtonText: this.$t("common.definite"),
            cancelButtonText: this.$t("common.cancel"),
            type: "warning"
          }
        ).then(() => {
          this.$api
            .request(this.$url.Machine.wtiSimAction, this.$method.post, {
              sim: sim.number,
              action: action,
              notes: `via VTM portal for machine ${row.equipmentNo}`
            })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t("machine.simActionQueued"));
              } else if (res.msg) {
                this.$message.error(res.msg);
              }
            });
        }).catch(() => {});
      },
      wtiEsimAction(row, sim, action) {
        const label = action === "deactivate" ? this.$t("machine.esimDeactivate") : this.$t("machine.esimActivate");
        this.$confirm(
          `${label} (EID ${sim.number}) — ${row.equipmentName || row.equipmentNo}?`,
          this.$t("common.tip"),
          {
            confirmButtonText: this.$t("common.definite"),
            cancelButtonText: this.$t("common.cancel"),
            type: "warning"
          }
        ).then(() => {
          this.$api
            .request(this.$url.Machine.wtiEsimAction, this.$method.post, {
              eid: sim.number,
              action: action,
              notes: `via VTM portal for machine ${row.equipmentNo}`
            })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t("machine.simActionQueued"));
              } else if (res.msg) {
                this.$message.error(res.msg);
              }
            });
        }).catch(() => {});
      },
      loadWtiInfo() {
        this.userMachineList.forEach(row => {
          const sn = row.wtiSerialNumber;
          if (!sn || this.wtiInfoMap[sn] !== undefined) {
            return;
          }
          if (this.isWtiAdmin) {
            this.$api
              .request(this.$url.Machine.wtiInfo, this.$method.get, { sn: sn })
              .then(res => {
                this.$set(this.wtiInfoMap, sn, res.code === 0 && res.data ? res.data : null);
              })
              .catch(() => {
                this.$set(this.wtiInfoMap, sn, null);
              });
          } else {
            // customers: simplified any-SIM-active flag via ownership-checked endpoint
            this.$api
              .request(this.$url.UserMachine.wtiSimStatus, this.$method.get, { id: row.id })
              .then(res => {
                this.$set(this.wtiInfoMap, sn, res.code === 0 ? { active: res.data } : null);
              })
              .catch(() => {
                this.$set(this.wtiInfoMap, sn, null);
              });
          }
        });
      },
      editWtiSerial(row) {
        this.$prompt(this.$t("machine.wtiSerialTip"), this.$t("machine.wtiSerial"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          inputValue: row.wtiSerialNumber || "",
          inputPattern: /^[0-9]*$/,
          inputErrorMessage: this.$t("machine.wtiSerialInvalid")
        }).then(({ value }) => {
          const serial = (value || "").trim();
          const req = this.isWtiAdmin
            ? this.$api.request(this.$url.Machine.updateWtiSerial, this.$method.put, {
                id: row.equipmentId,
                wtiSerialNumber: serial
              })
            : this.$api.request(this.$url.UserMachine.updateWtiSerial, this.$method.put, {
                id: row.id,
                wtiSerialNumber: serial
              });
          req.then(res => {
            if (res.code === 0) {
              if (row.wtiSerialNumber && this.wtiInfoMap[row.wtiSerialNumber] !== undefined) {
                this.$delete(this.wtiInfoMap, row.wtiSerialNumber);
              }
              row.wtiSerialNumber = serial || null;
              if (serial) {
                this.loadWtiInfo();
              }
              this.$message.success(this.$t("common.success"));
            }
          });
        }).catch(() => {});
      },
      async currentChange(pageIndex) {
        let _self = this;

        _self.page.pageIndex = pageIndex ? pageIndex : 1;

        // If we're sorting all machines by transactions, display from sorted cache
        if (_self.isSortingAllMachines && _self.allMachinesSorted.length > 0) {
          _self.displaySortedPage();
          return;
        }

        _self.loading = true;
        // 每次新建请求对象：objMerge 会改写第一个参数，直接传 search 会把指标卡的 mqState/attention
        // 永久写进筛选条件（点过“需要处理”再点“离线”就只剩离线且需要处理的机器）
        let obj = Object.assign({}, _self.search, _self.page, _self.statusParams());
        // 快速切换指标卡/筛选时，只采用最后一次请求的结果（旧请求晚返回会覆盖新列表）
        const seq = (_self.listSeq = (_self.listSeq || 0) + 1);
        try {
          const res = await _self.$api.request(_self.$url.UserMachine.page, _self.$method.get, obj);
          if (seq !== _self.listSeq) return;
          if (res.code === 0) {
            let records = res.data.records;

            for (let i = 0; i < records.length; i++) {
              let isshow = false;
              if (records[i]["userFinanceId"] == _self.uId && !isshow) {
                isshow = true;
              }
              records[i]["isshow"] = isshow;

              // 划分色块
              // 1.转数字
              let faultNum = records[i]["faultNum"] ? parseInt(records[i]["faultNum"]) : 0;
              let stockOutNum = records[i]["stockOutNum"] ? parseInt(records[i]["stockOutNum"]) : 0;
              let stockAlertNum = records[i]["stockAlertNum"] ? parseInt(records[i]["stockAlertNum"]) : 0;
              let stockNormalNum = records[i]["stockNormalNum"] ? parseInt(records[i]["stockNormalNum"]) : 0;
              // 2.求分母
              let total = faultNum + stockOutNum + stockAlertNum + stockNormalNum;
              // 3.定义总宽度
              let totalwidth = 200;

              // 新的划分方式 修改逻辑
              //  -1 全部赋值1/10 如果>0存在的话
              let all = 10;
              let faultNum1 = 0;
              //  -2保证每一个只要存在就占比1/10
              if (faultNum > 0) {
                faultNum1++;
                all--;
              }
              let stockOutNum1 = 0;
              if (stockOutNum > 0) {
                stockOutNum1++;
                all--;
              }

              let stockAlertNum1 = 0;
              if (stockAlertNum > 0) {
                stockAlertNum1++;
                all--;
              }

              let stockNormalNum1 = 0;
              if (stockNormalNum > 0) {
                stockNormalNum1++;
                all--;
              }
              if (total == 0) {
                faultNum1 = 2.5;
                stockOutNum1 = 2.5;
                stockAlertNum1 = 2.5;
                stockNormalNum1 = 2.5;
              } else {
                faultNum1 = faultNum1 + faultNum / all;
                stockOutNum1 = stockOutNum1 + stockOutNum / all;
                stockAlertNum1 = stockAlertNum1 + stockAlertNum / all;
                stockNormalNum1 = stockNormalNum1 + stockNormalNum / all;
              }
              records[i]["faultNumWidth"] = totalwidth * faultNum1;
              records[i]["stockOutNumWidth"] = totalwidth * stockOutNum1;
              records[i]["stockAlertNumWidth"] = totalwidth * stockAlertNum1;
              records[i]["stockNormalNumWidth"] = totalwidth * stockNormalNum1;

              // Initialize transaction loading state
              records[i]["transactionsLoading"] = true;
              records[i]["lastDeliveredTime"] = null;
            }

            // Load subscription states before rendering table so there's no flash
            await _self.loadSubscriptionStates(records);
            if (seq !== _self.listSeq) return;

            _self.userMachineList = records;
            _self.page.totalSize = parseInt(res.data.total);
            // 行数变化后（如 6 行在线 → 10 行离线）重新计算表格布局，避免固定列仍按旧行数显示
            _self.$nextTick(() => _self.$refs.machineTable && _self.$refs.machineTable.doLayout());

            // 详情面板开着时，用刷新后的行数据重建配置（见 syncDetail）
            if (_self.detailVisible && _self.activeMachine) {
              const fresh = records.find(r => r.id === _self.activeMachine.id);
              if (fresh) _self.syncDetail(fresh);
            }

            // Load notes data for all machines to get addresses
            _self.loadNotesForAllMachines();

            // Load last delivered transactions separately
            _self.loadLastDeliveredTransactions();

            // WTI SIM usage/status (admin columns only)
            _self.loadWtiInfo();
          }
        } catch (e) {
          // ignore
        }
        _self.loading = false;
      },

      async loadSubscriptionStates(machines) {
        const newStates = {};
        await Promise.all(
          machines.filter(m => m.stripeSubscriptionId).map(async machine => {
            try {
              const res = await this.$api.request(this.$url.RenewalRecord.page, this.$method.get, {
                equipmentNo: machine.equipmentNo,
                pageSize: 50,
                pageIndex: 1
              });
              if (res.code === 0 && res.data.records && res.data.records.length > 0) {
                const records = res.data.records;
                // 只看设备当前所属的那条订阅记录。原来是"任意一条 active 就算 active"，
                // 换过订阅的设备会被旧的、已被取代的记录带偏：
                // 明明当前订阅还在试用期，却显示 Active。
                // 自动续费的记录后端会把订阅号写成 "automatic_<subId>"，比对前先去掉这个前缀，
                // 否则续费扣款那条永远匹配不上，只能退回到首次订阅（试用）那条。
                const sameSub = r =>
                  String(r.stripeSubscriptionId || "").replace(/^automatic_/, "") === machine.stripeSubscriptionId;
                // 同一条订阅可能有多条记录（首次 + 每次续费），按付款时间取最新的那条看状态。
                const when = r => new Date(r.payTime || r.createTime || 0).getTime();
                const mine = records.filter(sameSub).sort((a, b) => when(b) - when(a));
                const current = mine[0] || records[0];
                // "Active" 只代表客户真的付过钱。Stripe 的 active 并不等于已扣款：
                // 试用期内、$0 发票、用余额抵扣的订阅同样是 active。
                // 后端在真扣到钱时把 trial_use 置 0，所以本订阅下只要有一条 trial_use=0 就说明付过钱了
                // ——续费扣款的客户首次那条仍是 trial_use=1，只看一条会把付费客户误判成试用。
                const hasPaid = (mine.length ? mine : [current]).some(r => Number(r.trialUse) === 0);
                newStates[machine.equipmentNo] =
                  current.stripeSubscriptionState === "active" && hasPaid ? "active" : "trialing";
              }
            } catch (e) {
              // ignore
            }
          })
        );
        this.subscriptionStates = newStates;
      },

      async loadNotesForAllMachines() {
        const promises = this.userMachineList.map(async machine => {
          try {
            const response = await this.$api.request(this.$url.Notes.getByMachineNo, this.$method.get, {
              machineNo: machine.equipmentNo
            });

            if (response.code === 0 && response.data) {
              // Update the machine in the list with address from notes
              const machineIndex = this.userMachineList.findIndex(m => m.equipmentNo === machine.equipmentNo);
              if (machineIndex !== -1) {
                const newAddress = response.data.address || response.data.locale || response.data.location || "";
                // Always update the locale field, even if it's empty/null
                this.$set(this.userMachineList, machineIndex, {
                  ...this.userMachineList[machineIndex],
                  locale: newAddress || null // Set to null if empty string
                });
              }
            } else if (response.code === 0 && !response.data) {
              // If no notes data found, ensure locale is null
              const machineIndex = this.userMachineList.findIndex(m => m.equipmentNo === machine.equipmentNo);
              if (machineIndex !== -1) {
                this.$set(this.userMachineList, machineIndex, {
                  ...this.userMachineList[machineIndex],
                  locale: null
                });
              }
            }
          } catch (error) {
            // On error, set locale to null
            const machineIndex = this.userMachineList.findIndex(m => m.equipmentNo === machine.equipmentNo);
            if (machineIndex !== -1) {
              this.$set(this.userMachineList, machineIndex, {
                ...this.userMachineList[machineIndex],
                locale: null
              });
            }
          }
        });

        await Promise.all(promises);
        // Force Vue to re-render the component to show updated addresses
        this.$forceUpdate();
      },

      async loadLastDeliveredTransactions() {
        if (this.userMachineList.length === 0) return;

        try {
          // Extract equipment numbers for current page
          const equipmentNos = this.userMachineList.map(m => m.equipmentNo);

          // Call separate API to get last delivered transactions
          const response = await this.$api.request(this.$url.UserMachine.lastDeliveredTransactions, this.$method.get, {
            equipmentNos
          });

          if (response.code === 0 && response.data) {
            // Merge transaction data into machine list
            this.userMachineList.forEach((machine, index) => {
              const transactionTime = response.data[machine.equipmentNo];
              this.$set(this.userMachineList[index], "lastDeliveredTime", transactionTime || null);
              this.$set(this.userMachineList[index], "transactionsLoading", false);
            });
            this.$forceUpdate();
          } else {
            // Set loading to false for all machines
            this.userMachineList.forEach((machine, index) => {
              this.$set(this.userMachineList[index], "transactionsLoading", false);
            });
          }
        } catch (error) {
          // Set loading to false for all machines on error
          this.userMachineList.forEach((machine, index) => {
            this.$set(this.userMachineList[index], "transactionsLoading", false);
          });
        }
      },

      async sortAllMachinesByTransaction() {
        this.loading = true;

        try {
          // 1. Fetch ALL machines (no pagination)
          // 新对象：不要把 pageSize 10000 写回 search
          const allMachinesParams = Object.assign({}, this.search, {
            pageSize: 10000, // Large number to get all machines
            pageIndex: 1
          }, this.statusParams());

          const allMachinesResponse = await this.$api.request(
            this.$url.UserMachine.page,
            this.$method.get,
            allMachinesParams
          );

          if (allMachinesResponse.code !== 0) {
            this.$message.error("Failed to load machines");
            this.loading = false;
            return;
          }

          const allMachines = allMachinesResponse.data.records;
          this.originalTotalSize = parseInt(allMachinesResponse.data.total);

          // 2. Fetch transactions for ALL machines
          const allEquipmentNos = allMachines.map(m => m.equipmentNo);
          const transactionsResponse = await this.$api.request(
            this.$url.UserMachine.lastDeliveredTransactions,
            this.$method.get,
            { equipmentNos: allEquipmentNos }
          );

          if (transactionsResponse.code !== 0) {
            this.$message.error("Failed to load transactions");
            this.loading = false;
            return;
          }

          // 3. Merge transaction data into all machines
          allMachines.forEach(machine => {
            machine.lastDeliveredTime = transactionsResponse.data[machine.equipmentNo] || null;
            machine.transactionsLoading = false;
          });

          // 4. Sort all machines by transaction time
          allMachines.sort((a, b) => {
            const hasTimeA = a.lastDeliveredTime && a.lastDeliveredTime !== null;
            const hasTimeB = b.lastDeliveredTime && b.lastDeliveredTime !== null;

            // Handle nulls: machines without transactions go to the end
            if (!hasTimeA && !hasTimeB) return 0;
            if (!hasTimeA) return 1; // a goes after b
            if (!hasTimeB) return -1; // b goes after a

            // Both have transactions, compare times
            const timeA = new Date(a.lastDeliveredTime).getTime();
            const timeB = new Date(b.lastDeliveredTime).getTime();

            if (this.transactionSortOrder === "asc") {
              return timeA - timeB; // Oldest first
            } else {
              return timeB - timeA; // Newest first
            }
          });

          // 5. Store sorted results and show first page
          this.allMachinesSorted = allMachines;
          this.isSortingAllMachines = true;
          this.page.pageIndex = 1;
          this.displaySortedPage();
        } catch (error) {
          this.$message.error("Failed to sort machines");
          this.isSortingAllMachines = false;
        } finally {
          this.loading = false;
        }
      },

      displaySortedPage() {
        const startIndex = (this.page.pageIndex - 1) * this.page.pageSize;
        const endIndex = startIndex + this.page.pageSize;
        const pageRecords = this.allMachinesSorted.slice(startIndex, endIndex);

        this.userMachineList = pageRecords;
        this.page.totalSize = this.allMachinesSorted.length;

        // Load notes for displayed machines
        this.loadNotesForAllMachines();
        this.loadSubscriptionStates(pageRecords);
        this.$forceUpdate();
      },

      onSubmit(data) {
        this.search = data;
        // Clear transaction sorting cache when search changes
        this.transactionSortOrder = null;
        this.isSortingAllMachines = false;
        this.allMachinesSorted = [];
        // 套用保存的视图时，search.sort/order 会被一并还原；
        // 这里把表头的排序箭头同步过去，否则数据已排序但列头看不出来
        this.$nextTick(() => {
          const table = this.$refs.machineTable;
          if (!table) {
            return;
          }
          // table.sort()/clearSort() 会派发 sort-change，若不屏蔽会再触发一次请求
          this.syncingSort = true;
          if (this.search.sort) {
            table.sort(this.search.sort, this.search.order === "asc" ? "ascending" : "descending");
          } else {
            table.clearSort();
          }
          this.$nextTick(() => {
            this.syncingSort = false;
          });
        });
        this.currentChange();
      },
      // Format backend datetime to readable format
      formatBackendDateTime(dateTimeString) {
        if (!dateTimeString) return "";
        try {
          const date = new Date(dateTimeString);
          if (isNaN(date.getTime())) return "";

          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        } catch (e) {
          return "";
        }
      },
      setStatusFilter(kind) {
        this.statusFilter = kind && this.statusFilter !== kind ? kind : "";
        this.view = "list";
        // 与重置一致：清掉跨页交易排序缓存，否则会继续显示缓存里的全部机器
        this.transactionSortOrder = null;
        this.isSortingAllMachines = false;
        this.allMachinesSorted = [];
        this.currentChange(1);
      },
      statusParams() {
        if (this.statusFilter === "online") return { mqState: "1" };
        if (this.statusFilter === "offline") return { mqState: "0" };
        if (this.statusFilter === "attention") return { attention: 1 };
        return {};
      },
      resetSearch(data) {
        this.search = data;
        // Clear transaction sorting cache when search resets
        this.transactionSortOrder = null;
        this.isSortingAllMachines = false;
        this.allMachinesSorted = [];
        this.currentChange();
      },
      faultStatus(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.faultStatus);
      },
      isPort(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.port);
      },
      enableStatus(row) {
        // console.log(row.enableStatus);
        return this.$cloud.getDictLabel(this.yesNo, row.enableStatus);
      },
      // 调试开关存在 config.manager（不是 config.info）
      isDebug(row) {
        const c = row.config || {};
        const v = c.manager && c.manager.isDebug != null && c.manager.isDebug !== "" ? c.manager.isDebug : c.info && c.info.isDebug;
        return this.$cloud.getDictLabel(this.yesNo, v);
      },
      // 遥控器 / 手感遥控：绝大多数机器从未设置（无 config.remote），与设置页一致按「否」显示
      isRemoteControl(row) {
        const r = (row.config && row.config.remote) || {};
        return this.$cloud.getDictLabel(this.yesNo, r.isBlue != null && r.isBlue !== "" ? r.isBlue : 0);
      },
      isFeelControl(row) {
        const r = (row.config && row.config.remote) || {};
        return this.$cloud.getDictLabel(this.yesNo, r.isHaptic != null && r.isHaptic !== "" ? r.isHaptic : 0);
      },
      isDoubleScreen(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.isDoubleScreen);
      },
      isLock(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.isLock);
      },
      isSms(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.config && row.config.info && row.config.info.isSms);
      },
      isCart(row) {
        return this.$cloud.getDictLabel(this.yesNo, row.isCart);
      },
      formatterPayType(row) {
        return this.$cloud.getDictLabel(this.payTypeList, row.payType);
      },
      isOutDate(row) {
        // Far-future sentinel (no expiry until the customer subscribes)
        if (row.expireDate && new Date(row.expireDate).getFullYear() >= 2090) {
          return "Not subscribed";
        }
        if (row.isOutDate <= 30 && row.isOutDate > 0) {
          return this.$t("machineUser.nExpired").replace("N", row.isOutDate);
        } else if (row.isOutDate <= 0) {
          return this.$t("machineUser.beExpired");
        }
        return row.expireDate.split(" ")[0];
      },
      openSettings(row) {
        this.userEquipment = JSON.parse(JSON.stringify(row));
        this.userEquipment.id = row.id;
        this.payment = {
          equipmentNo: row.equipmentNo,
          id: row.id,
          payConfig: row.payConfig ? JSON.parse(JSON.stringify(row.payConfig)) : {}
        };
        this.ConfigSubmit.config = JSON.parse(JSON.stringify(row.config));
        this.ConfigSubmit.equipmentNo = row.equipmentNo;
        this.ConfigSubmit.id = row.id;
        this.ConfigSubmit.verify = row.verify ? JSON.parse(JSON.stringify(row.verify)) : [];
        this.ConfigSubmit.walletPrice = row.walletPrice;
        this.$set(this.ConfigSubmit, "mqState", row.mqState);
        this.dialogMachineSettings = true;
      },
      editUserMachine(row) {
        // 创建深拷贝，避免污染表格数据
        this.userEquipment = JSON.parse(JSON.stringify(row));
        this.userEquipment.id = row.id;
        this.dialogUserMachine = true;
      },
      configUserMachine(row) {
        // 创建深拷贝，避免污染表格数据
        this.ConfigSubmit.config = JSON.parse(JSON.stringify(row.config));
        this.ConfigSubmit.equipmentNo = row.equipmentNo;
        this.ConfigSubmit.id = row.id;
        this.ConfigSubmit.verify = row.verify ? JSON.parse(JSON.stringify(row.verify)) : [];
        this.ConfigSubmit.walletPrice = row.walletPrice;
        this.$set(this.ConfigSubmit, "mqState", row.mqState);
        this.dialogConfigMachine = true;
      },
      machineLineProduct(row) {
        // console.log(row);
        // 创建深拷贝，避免直接引用表格数据
        this.userEquipment = JSON.parse(JSON.stringify(row));
        this.userEquipment.id = row.id;
        this.dialogMachineLineProduct = true;
      },
      // 从设备详情飞出的"广告"页签深链到 Adverts 枢纽，预筛选到该设备
      openMachineAds(machine) {
        this.detailVisible = false;
        this.$router.push({ path: "/adverts/adverts", query: { view: "machineAds", equipmentNo: machine.equipmentNo } });
      },

      handleControl(item) {
        let _self = this;
        this.nowRemoteInfo = item;
        const loading = _self.$loading({
          lock: true,
          text: _self.$t("common.ljload"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        _self.$api
          .request(_self.$url.UserMachine.control, _self.$method.post, {
            equipmentNo: item.equipmentNo
          })
          .then(res => {
            if (res.code == 0) {
              // 还原次数
              _self.countError = 0;
              //  监听远程控制连接状态
              _self.getYCKZControl(item.equipmentNo, loading);
            } else {
              loading.close();
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(() => {
            loading.close();
            _self.$notify({
              title: _self.$t("common.tip"),
              message: "reqest error",
              type: "warning"
            });
          });
      },
      // 延迟函数
      async delay(time) {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, time);
        });
      },
      //  监听远程控制连接状态
      async getYCKZControl(equipmentNo, loading) {
        let _self = this;
        await this.delay(3000);
        // 调用一次++
        this.countError++;
        if (this.countError > 20) {
          this.$message.warning(this.$t("user.MachineMaps.588934-10"));
          loading.close();
          if (!(this.nowRemoteInfo.remoteCode && this.nowRemoteInfo.remoteId && this.nowRemoteInfo.gotoHttpUrl)) {
            //超时
            return;
          }
          this.control.remoteCode = this.nowRemoteInfo.remoteCode;
          this.control.remoteId = this.nowRemoteInfo.remoteId;
          this.control.url = this.nowRemoteInfo.gotoHttpUrl;
          let djs = setTimeout(function () {
            clearTimeout(djs);
            _self.$refs.btnForm.click();
          }, 1000);
          return;
        }
        //  执行连接状态检测
        _self.$api
          .request(_self.$url.UserMachine.getcontrol, _self.$method.get, {
            equipmentNo
          })
          .then(res => {
            if (res.code == 0) {
              if (res.data && res.data.remoteState == 2) {
                loading.close();
                //  连接成功
                _self.control.remoteCode = res.data.remoteCode;
                _self.control.remoteId = res.data.remoteId;
                _self.control.url = res.data.gotoHttpUrl;
                let djs = setTimeout(function () {
                  clearTimeout(djs);
                  _self.$refs.btnForm.click();
                }, 1000);
                return;
              } else if (res.data && res.data.remoteState == -1) {
                loading.close();
                _self.$notify({
                  title: _self.$t("common.tip"),
                  message: _self.$t("common.ljfail"),
                  type: "error"
                });
              } else {
                //  休息1秒
                let djs = setTimeout(function () {
                  clearTimeout(djs);
                  _self.getYCKZControl(equipmentNo, loading);
                }, 1000);
              }
            } else {
              loading.close();
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(res => {
            loading.close();
            _self.$notify({
              title: _self.$t("common.tip"),
              message: JSON.stringify(res),
              type: "error"
            });
          });
      },
      // 弹出地图弹框
      machineMaps(row) {
        this.dialogMachineMaps = true;
        // 创建深拷贝，避免污染表格数据
        this.userEquipment = JSON.parse(JSON.stringify(row));
        this.userEquipment.id = row.id;
      },
      // 隐藏地图弹框
      mapsCancel(dialog, state) {
        this.dialogMachineMaps = dialog;
      },
      // Handle address updates from UserMachineMap component
      handleAddressUpdated(addressData) {
        // Update the machine in the userMachineList
        const machineIndex = this.userMachineList.findIndex(machine => machine.equipmentNo === addressData.machineNo);

        if (machineIndex !== -1) {
          // Update the machine with new address data
          this.$set(this.userMachineList, machineIndex, {
            ...this.userMachineList[machineIndex],
            locale: addressData.address,
            lat: addressData.lat,
            lng: addressData.lng
          });

          // Also update the Notes table to keep everything in sync
          this.updateNotesAddress(addressData);

          // Force Vue to re-render the component
          this.$forceUpdate();

          // Notify Location.vue component to refresh its data
          eventBus.emit("machineAddressUpdated", addressData);

          // Show success message
          this.$notify({
            title: this.$t("common.tip"),
            message: "Address updated successfully",
            type: "success"
          });
        }
      },

      // Handle address updates from Location.vue component
      handleAddressUpdatedFromLocation(addressData) {
        // console.log('MachineUser received address update from Location.vue:', addressData);

        // Update the machine in the userMachineList
        const machineIndex = this.userMachineList.findIndex(machine => machine.equipmentNo === addressData.machineNo);

        if (machineIndex !== -1) {
          // Update the machine with new address data
          this.$set(this.userMachineList, machineIndex, {
            ...this.userMachineList[machineIndex],
            locale: addressData.address,
            lat: addressData.lat,
            lng: addressData.lng
          });

          // Force Vue to re-render the component
          this.$forceUpdate();

          // console.log('MachineUser updated machine list with new address from Location.vue');
        } else {
          // console.log('Machine not found in MachineUser list:', addressData.machineNo);
        }
      },

      // Update Notes table with new address from UserMachineMap
      updateNotesAddress(addressData) {
        // Find the machine to get its notes data
        const machine = this.userMachineList.find(m => m.equipmentNo === addressData.machineNo);
        if (!machine) {
          return;
        }

        // Prepare notes update payload
        const notesUpdatePayload = {
          machineNo: addressData.machineNo,
          machineId: addressData.machineId || machine.id,
          address: addressData.address,
          lat: addressData.lat || "",
          lng: addressData.lng || "",
          contactName: machine.notesData?.contactName || "",
          phoneNumber: machine.notesData?.phoneNumber || "",
          email: machine.notesData?.email || "",
          notesContent: machine.notesData?.notesContent || "",
          installDate: machine.notesData?.installDate || ""
        };

        // Update the notes table
        this.$api
          .request(this.$url.Notes.updateByMachineNo, this.$method.put, notesUpdatePayload)
          .then(res => {
            if (res?.code === 0) {
              // Update the machine's notesData with the new address
              const machineIndex = this.userMachineList.findIndex(m => m.equipmentNo === addressData.machineNo);
              if (machineIndex !== -1) {
                this.$set(this.userMachineList, machineIndex, {
                  ...this.userMachineList[machineIndex],
                  notesData: {
                    ...this.userMachineList[machineIndex].notesData,
                    address: addressData.address,
                    lat: addressData.lat,
                    lng: addressData.lng
                  }
                });
              }
            }
          })
          .catch(err => {
            // Error updating notes table
          });
      },


      payType(row) {
        this.dialogPayment = true;
        // 创建深拷贝，避免污染表格数据
        this.payment = {
          equipmentNo: row.equipmentNo,
          id: row.id,
          payConfig: row.payConfig ? JSON.parse(JSON.stringify(row.payConfig)) : {}
        };
      },
      // 新设备订阅：打开续费弹窗并传入单设备
      async subscribeNewDevice(row) {
        try {
          // 取消所有勾选状态，避免与单设备订阅混淆
          if (this.$refs && this.$refs.machineTable && this.$refs.machineTable.clearSelection) {
            this.$refs.machineTable.clearSelection();
          }
          this.multipleSelection = [];

          // 防御性判断：仅处理未订阅设备
          // const payType = row && row.stripeSubscriptionPayType;
          // const notSubscribed = payType == null || payType === 0 || payType === '0';
          // if (!notSubscribed) {
          //   this.$message.warning(this.$t('common.ywc') || 'Already subscribed');
          //   return;
          // }
          // 设置选中列表为当前设备，打开续费弹窗
          this.selectList = [row];
          this.nickName = row && row.nickName ? row.nickName : "";
          this.dialogBatchRenewal = true;
        } catch (e) {
          this.$message.error(this.$t("user.MachineRenewal.456993-36") || "Request failed");
        }
      },
      handleShowNet(row, index) {
        let _self = this;
        let clipboard = new Clipboard("#fz" + index);
        clipboard.on("success", e => {
          _self.$message({
            message: this.$t("userMachineLineProduct.fzcg"),
            type: "success"
          });
          clipboard.destroy();
          return false;
        });
        //  获取二维码
        _self.qrloading = true;
        this.$api
          .request(this.$url.UserMachine.getQrCode, this.$method.get, {
            path: row.twoCode
          })
          .then(res => {
            _self.pzqrcode = res.data;
          })
          .catch(() => {
            this.qrloading = false;
          });
      },
      imgLoad() {
        let _self = this;
        _self.qrloading = false;
      },
      cancel(dialog, state) {
        this.dialogUserMachine = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      configCancel(dialog, state) {
        this.dialogConfigMachine = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      // 隐藏货道商品弹框
      lineProductCancel(dialog) {
        this.dialogMachineLineProduct = dialog;
      },
      // 修改mode
      changeOpenMode(mode) {
        this.userMachineList.forEach(item => {
          if (item.id == this.userEquipment.id) {
            item.lineProductMode = Number(mode) - 1;
          }
        });
      },
      // 批量续费（从子组件接收选中列表，确保弹窗展示设备信息）
      batchRenewal(selectedList) {
        // 如果子组件传了选中列表，进行同步
        if (Array.isArray(selectedList) && selectedList.length > 0) {
          this.selectList = selectedList;
        }

        // 无选中设备时给出提示
        if (!Array.isArray(this.selectList) || this.selectList.length === 0) {
          this.$message.warning(this.$t("searchUserMachine.check"));
          return;
        }

        // // 校验是否包含旧设备：仅允许 isTransferNew == 1 且没有 stripeSubscriptionId
        // const hasOldDevice = this.selectList.some(row => {
        //   return Number(row.isTransferNew) !== 1 || !!row.stripeSubscriptionId;
        // });
        // if (hasOldDevice) {
        //   this.$message.warning(this.$t('machineUser.noRepeatOldRenewal'));
        //   return;
        // }
        // 打开续费弹窗，并设置昵称
        this.dialogBatchRenewal = true;
        this.nickName = this.selectList[0] && this.selectList[0].nickName ? this.selectList[0].nickName : "";
      },
      cancelRenewal(dialog, state) {
        this.dialogBatchRenewal = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },

      // 批量管理
      batchManage() {
        this.dialogManage = true;
      },

      // Open address dialog when clicking on address link
      openAddressDialog(row) {
        this.selectedMachine = row;
        // console.log('Opening address dialog for row:', row);
        // console.log('Machine equipment number:', row.equipmentNo);
        // console.log('Machine name:', row.equipmentName);

        this.addressForm.location = row.locale || "";
        this.addressForm.machineNo = row.equipmentNo || "";

        // console.log('Address form set to:', {
        //   location: this.addressForm.location,
        //   machineNo: this.addressForm.machineNo
        // });

        this.getNotesByMachineNo(row.equipmentNo);
        this.addressDialogVisible = true;
      },

      getNotesByMachineNo(machineNumber) {
        let _self = this;
        // console.log('Fetching notes for machine:', machineNumber);
        return _self.$api
          .request(_self.$url.Notes.getByMachineNo, _self.$method.get, {
            machineNo: machineNumber
          })
          .then(res => {
            // console.log('getNotesByMachineNo response:', res);
            if (res?.code === 0 && res?.data) {
              // console.log('Found existing notes, populating form...');
              this.addressForm = {
                ...this.addressForm,
                machineNo: this.addressForm.machineNo, // Explicitly preserve machineNo
                location: res.data.address || res.data.locale || this.addressForm.location,
                Contact: res.data.contactName || "",
                PhoneNumber: res.data.phoneNumber || "",
                email: res.data.email || "",
                Notes: res.data.notesContent || "",
                Installed: res.data.installDate || ""
              };
              // console.log('Address form after notes update:', this.addressForm);
            } else {
              // console.log('No existing notes found, using empty form');
            }
            return Promise.resolve();
          })
          .catch(err => {
            return Promise.resolve();
          });
      },

      // Handle address search suggestions
      querySearch(queryString, cb) {
        if (!queryString) {
          cb([]);
          return;
        }
        const loader = new Loader({
          apiKey: "AIzaSyA1Rd3GCCRnoZU1dmTRgFZoRaLcsq13BOw",
          version: "weekly",
          libraries: ["places"]
        });
        loader.load().then(google => {
          const autocompleteService = new google.maps.places.AutocompleteService();
          const placesService = new google.maps.places.PlacesService(document.createElement("div"));
          autocompleteService.getPlacePredictions(
            {
              input: queryString,
              types: ["establishment", "geocode"],
              componentRestrictions: { country: "us" }
            },
            (predictions, status) => {
              if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
                cb([]);
                return;
              }
              // For each prediction, fetch full address
              const fetchDetails = predictions.map(prediction => {
                return new Promise(resolve => {
                  placesService.getDetails(
                    {
                      placeId: prediction.place_id,
                      fields: ["name", "formatted_address", "address_components", "geometry"]
                    },
                    (place, status) => {
                      let county = "";
                      let lat = "";
                      let lng = "";
                      if (status === google.maps.places.PlacesServiceStatus.OK && place) {
                        if (place.address_components) {
                          const countyComp = place.address_components.find(comp =>
                            comp.types.includes("administrative_area_level_2")
                          );
                          if (countyComp) {
                            county = countyComp.long_name;
                            county = county.replace(/\s*County$/i, "").trim();
                          }
                        }
                        if (place.geometry && place.geometry.location) {
                          lat = place.geometry.location.lat();
                          lng = place.geometry.location.lng();
                        }

                        resolve({ name: place.name, address: place.formatted_address, county, lat, lng });
                      } else {
                        resolve({
                          name: prediction.structured_formatting.main_text,
                          address: prediction.structured_formatting.secondary_text || prediction.description,
                          county: "",
                          lat: "",
                          lng: ""
                        });
                      }
                    }
                  );
                });
              });
              Promise.all(fetchDetails).then(results => {
                cb(results);
              });
            }
          );
        });
      },

      // Handle address selection from suggestions
      handleAddressSelect(item) {
        this.addressForm.location = item.address;
        this.addressForm.lat = item.lat;
        this.addressForm.lng = item.lng;
      },

      // Clear address input
      clearAddress() {
        this.addressForm.location = "";
        this.addressForm.lat = null;
        this.addressForm.lng = null;
      },

      // Clean address to remove duplication pattern
      cleanAddress(address) {
        if (!address) return address;

        // console.log('Cleaning address:', address);

        // Pattern to match: "Street Name, County, Street Name, City, State, ZIP, Country"
        // Example: "7921 Simon Ave, Cuyahoga, 7921 Simon Ave, Cleveland, OH 44103, USA"
        // More flexible pattern to handle various formats
        const duplicatePattern = /^(.+?),\s*([^,]+),\s*\1,\s*(.+)$/;
        const match = address.match(duplicatePattern);

        if (match) {
          // console.log('Found duplicate pattern, cleaning:', match);
          // Return: "Street Name, City, State, ZIP, Country"
          const cleaned = `${match[1]}, ${match[3]}`;
          // console.log('Cleaned address:', cleaned);
          return cleaned;
        }

        // console.log('No duplicate pattern found, returning original');
        return address;
      },

      // Save address
      async saveAddress() {
        if (!this.addressForm.location) {
          this.$message.warning("Please enter an address");
          return;
        }

        // console.log('Saving address for machine:', this.addressForm.machineNo);
        // console.log('Address form data:', this.addressForm);
        // console.log('Selected machine:', this.selectedMachine);

        // If coordinates are missing, geocode the address
        let lat = this.addressForm?.lat || "";
        let lng = this.addressForm?.lng || "";

        if (!lat || !lng) {
          // console.log('Coordinates missing, geocoding address:', this.addressForm.location);
          try {
            const coordinates = await this.geocodeAddress(this.addressForm.location);
            if (coordinates) {
              lat = coordinates.lat;
              lng = coordinates.lng;
              // console.log('Geocoded coordinates:', coordinates);
            }
          } catch (error) {
            this.$message.warning(
              "Could not get coordinates for the address. The address will be saved without map coordinates."
            );
          }
        }

        const addressPayload = {
          address: this.addressForm?.location,
          lat: lat,
          lng: lng,
          machineNo: this.addressForm.machineNo
        };

        // console.log('Address payload being sent:', addressPayload);

        try {
          // Find the machine to get its ID
          const machine = this.userMachineList.find(m => m.equipmentNo === this.addressForm.machineNo);
          if (!machine) {
            this.$message.error("Machine not found");
            return;
          }

          // Update both the main machine data AND the notes table for synchronization
          const machineUpdatePayload = {
            id: machine.id,
            teamId: machine.teamId, // Preserve teamId to prevent machine group from being removed
            locale: this.addressForm.location,
            lat: lat,
            lng: lng
          };

          const notesUpdatePayload = {
            machineNo: this.addressForm.machineNo,
            machineId: machine.id,
            address: this.addressForm.location,
            lat: lat,
            lng: lng,
            contactName: this.addressForm.Contact || "N/A",
            phoneNumber: this.addressForm.PhoneNumber || "",
            email: this.addressForm.email || "",
            notesContent: this.addressForm.Notes || "",
            installDate: this.addressForm.Installed || ""
          };

          // console.log('Updating machine data:', machineUpdatePayload);
          // console.log('Updating notes data for sync:', notesUpdatePayload);

          // Update both APIs simultaneously
          const [machineRes, notesRes] = await Promise.all([
            this.$api.request(this.$url.UserMachine.update, this.$method.put, machineUpdatePayload),
            this.$api.request(this.$url.Notes.updateByMachineNo, this.$method.put, notesUpdatePayload)
          ]);

          // console.log('Machine update response:', machineRes);
          // console.log('Notes update response:', notesRes);

          if (machineRes?.code === 0 && notesRes?.code === 0) {
            this.$message.success("Address updated successfully");
            this.addressDialogVisible = false;
            this.currentChange(); // Refresh the table
            // console.log('Address updated successfully in both main data and notes table - Location.vue should now see the changes');

            // Refresh the data from server to ensure all locations are synchronized
            setTimeout(() => {
              // console.log('Refreshing MachineUser data from server...');
              this.currentChange(); // Reload all machine data from server
            }, 1000);
          } else {
            this.$message.error(machineRes?.msg || notesRes?.msg || "Failed to update address");
          }
        } catch (error) {
          this.$message.error("Failed to update address");
        }
      },

      // Geocode an address to get coordinates
      geocodeAddress(address) {
        return new Promise((resolve, reject) => {
          if (!address) {
            reject(new Error("No address provided"));
            return;
          }

          const loader = new Loader({
            apiKey: "AIzaSyA1Rd3GCCRnoZU1dmTRgFZoRaLcsq13BOw",
            version: "weekly",
            libraries: ["places"]
          });

          loader
            .load()
            .then(google => {
              const geocoder = new google.maps.Geocoder();

              geocoder.geocode({ address: address }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
                  const location = results[0].geometry.location;
                  const coordinates = {
                    lat: location.lat(),
                    lng: location.lng()
                  };
                  // console.log('Geocoding successful:', address, '->', coordinates);
                  resolve(coordinates);
                } else {
                  reject(new Error(`Geocoding failed: ${status}`));
                }
              });
            })
            .catch(error => {
              reject(error);
            });
        });
      },

      async saveNotesData() {
        try {
          const notesPayload = {
            machineNo: this.addressForm.machineNo,
            machineId: this.selectedMachine?.id || "",
            contactName: this.addressForm.Contact || "N/A",
            phoneNumber: this.addressForm.PhoneNumber || "",
            email: this.addressForm.email || "",
            address: this.addressForm?.location || "",
            lng: this.addressForm?.lng || "",
            lat: this.addressForm?.lat || "",
            notesContent: this.addressForm.Notes || "",
            installDate: this.addressForm.Installed || ""
          };

          // console.log('Saving notes data:', notesPayload);

          const response = await this.$api.request(this.$url.Notes.updateByMachineNo, this.$method.put, notesPayload);

          // console.log('Notes save response:', response);

          if (response.code === 0) {
            // Notes data saved successfully
          }
        } catch (error) {
          // Error saving notes data
        }
      },

      cancelManage(dialog, state) {
        this.dialogManage = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      selectable(row) {
        return row.rentState != 1 || this.uId == row.uId;
      },
      // 支付方式弹框关闭
      cancelPayment(dialog, state) {
        this.dialogPayment = dialog;
        if (state) {
          const page = this.page.pageIndex;
          this.currentChange(page);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  /* Machines Hub 布局 */
  .mh-head {
    padding: 16px 16px 0;
  }
  .mh-kpis {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
    padding: 10px 16px 12px;

    > div {
      cursor: pointer;
      border-radius: 10px;
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
    /* 当前作为筛选条件的指标卡 */
    > div.is-active {
      outline-color: var(--vtm-mint);
    }
  }
  /* 单行工具条 */
  .mh-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 16px 10px;
  }
  .mh-seg-group {
    flex-shrink: 0;
  }
  .mh-search {
    flex: 1;
    min-width: 0;
  }
  .mh-hint {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0 16px 8px;
    font-size: 12px;
    color: var(--vtm-ink-3);

    i {
      color: var(--vtm-mint-ink);
    }
  }
  /* 主列：机名加粗 + 编号副行 */
  .mh-name {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
  }
  .mh-name--stack {
    flex-direction: column;
    align-items: flex-start;
    gap: 1px;
  }
  .mh-name__text {
    font-weight: 600;
    color: var(--vtm-heading);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }
  .mh-name__no {
    font-size: 11px;
    color: var(--vtm-ink-3);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }

  /* 一键操作按钮（远程登录 / 货道管理） */
  .mh-quick {
    display: inline-flex;
    gap: 4px;
  }
  .mh-quick__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: 1px solid var(--vtm-line);
    border-radius: 8px;
    background: var(--vtm-surface);
    color: var(--vtm-ink-2);
    font-size: 14px;
    cursor: pointer;
    transition: background-color var(--vtm-speed) ease, color var(--vtm-speed) ease, border-color var(--vtm-speed) ease;

    &:hover:not(:disabled) {
      background: var(--vtm-mint-soft);
      border-color: var(--vtm-mint-dim, var(--vtm-mint));
      color: var(--vtm-mint-ink);
    }
    &:disabled {
      opacity: 0.35;
      cursor: not-allowed;
    }
  }
  /* 操作列：一键按钮 + 管理入口 */
  .mh-quick {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
  .mh-manage {
    padding: 6px 10px;
  }
  /* 悬停行时点亮管理入口，强化「可点开」暗示 */
  ::v-deep .el-table__row:hover .mh-manage {
    background: var(--vtm-mint-soft);
    border-color: var(--vtm-mint-dim, var(--vtm-mint));
  }
  .mh-quick__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: 1px solid var(--vtm-line);
    border-radius: 8px;
    background: var(--vtm-surface);
    color: var(--vtm-ink-2);
    font-size: 14px;
    cursor: pointer;
    transition: background-color var(--vtm-speed) ease, color var(--vtm-speed) ease, border-color var(--vtm-speed) ease;

    &:hover:not(:disabled) {
      background: var(--vtm-mint-soft);
      border-color: var(--vtm-mint-dim, var(--vtm-mint));
      color: var(--vtm-mint-ink);
    }
    &:disabled {
      opacity: 0.35;
      cursor: not-allowed;
    }
  }
  .mh-map {
    position: relative;
    height: 72vh;
    margin: 0 16px 16px;
  }
  .mh-groups {
    padding: 0 4px;
  }
  .machine-user .table.vue-padding .el-table__row {
    cursor: pointer;
  }

  .track-bar {
    display: flex;
    width: 100%;
    height: 28px;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
  }
  .track-segment {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 600;
    color: #fff;
    min-width: 0;
    cursor: pointer;
    transition: opacity 0.15s;
    &:hover { opacity: 0.85; }
  }
  .track-fault  { background-color: #555555; }
  .track-out    { background-color: #E44D60; }
  .track-alert  { background-color: #F1C901; color: #555; }
  .track-normal { background-color: #09BB07; }
  .track-empty  { background-color: var(--vtm-line); color: var(--vtm-ink-2); font-size: 12px; }

  .btn {
    display: inline-block;
    background-color: var(--vtm-mint);
    color: white;
    padding: 10px 0;
    text-align: center;
    border-radius: 6px;
    width: 45%;
    cursor: pointer;
  }
  ::v-deep .el-table th {
    padding: 8px 0;
  }
  .table {
    overflow: visible;
  }
  .table .el-table .warning-row {
    background: transparent;
  }
  .table .el-table .hover-row {
    color: var(--vtm-ink-2);
  }
  .machine-user .image {
    position: absolute;
  }
  .machine-user .maturity {
    color: var(--vtm-crit);
  }
  .machine-user .renew {
    color: var(--vtm-ok);
  }
  .machine-user .active-subscription {
    color: var(--vtm-mint-ink);
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 4px 8px;
    border-radius: 4px;
    display: inline-block;
  }
  .machine-user .active-subscription:hover {
    background-color: var(--vtm-mint-soft);
    color: var(--vtm-mint-ink);
    transform: scale(1.05);
  }
  ::v-deep .eCigarette {
    border-radius: 6px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial,
      sans-serif;
    .el-dialog__header {
      padding: 15px 15px 15px 20px;
      background-color: var(--vtm-mint);
      border-radius: 5px 5px 0 0;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: white;
    }
    .el-dialog__title {
      color: white;
    }
    .el-dialog__body {
      padding: 20px;
    }
    .el-form--label-top .el-form-item__label {
      padding: 0;
    }
    .el-form-item {
      margin: 0;
    }
    .el-dialog__headerbtn {
      top: 20px;
      right: 15px;
    }
  }
  .sekuai_tip {
    color: var(--vtm-ink-2);
    font-size: 0.14rem;
    display: flex;
    align-items: center;
    .sekuai {
      display: flex;
      align-items: center;
      margin-left: 10px;
      &:nth-of-type(1) {
        &::before {
          content: "";
          width: 20px;
          height: 20px;
          margin-right: 5px;
          background-color: #555555;
        }
      }
      &:nth-of-type(2) {
        &::before {
          content: "";
          width: 20px;
          height: 20px;
          margin-right: 5px;
          background-color: #e44d60;
        }
      }
      &:nth-of-type(3) {
        &::before {
          content: "";
          width: 20px;
          height: 20px;
          margin-right: 5px;
          background-color: #f1c901;
        }
      }
      &:nth-of-type(4) {
        &::before {
          content: "";
          width: 20px;
          height: 20px;
          margin-right: 5px;
          background-color: #09bb07;
        }
      }
    }
  }
  .rowClass {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
  }
  .dialog-title-left {
    display: block;
    text-align: left;
    font-size: 22px;
    font-weight: 600;
    color: var(--vtm-ink);
    padding-left: 4px;
  }

  .address-suggestion-dropdown {
    min-width: 350px;
  }

  .address-suggestion-item {
    display: flex;
    align-items: flex-start;
    /* align icon and text at the top */
    padding: 6px 10px;
  }

  .location-icon-bg {
    flex: 0 0 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--vtm-well);
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    margin-right: 10px;
  }

  .location-icon-bg .el-icon {
    font-size: 18px;
    color: var(--vtm-mint-ink);
  }

  .suggestion-text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }

  .suggestion-title,
  .suggestion-address {
    display: -webkit-box;
    line-clamp: 1;
    -webkit-line-clamp: 1;
    /* max 2 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    white-space: normal;
    /* allow wrapping but clamp */
  }

  .suggestion-title {
    font-weight: 600;
    font-size: 14px;
    color: var(--vtm-ink);
    margin-bottom: 2px;
    line-height: 1.4;
  }

  .suggestion-address {
    font-size: 12px;
    color: var(--vtm-ink-2);
    line-height: 1.3;
  }
  .ip-icon {
    margin-top: 13px;
  }

  /* Always show both sort arrows for Last Delivered Transaction column */
  .el-table .el-table__header-wrapper th.el-table__cell .cell .caret-wrapper {
    display: inline-flex !important;
    flex-direction: column !important;
    height: 14px !important;
  }

  .el-table .el-table__header-wrapper th.el-table__cell .cell .sort-caret {
    display: block !important;
    opacity: 1 !important;
  }

  .el-table .el-table__header-wrapper th.el-table__cell .cell .sort-caret.ascending {
    border-bottom-color: var(--vtm-line-2) !important;
    top: 0 !important;
  }

  .el-table .el-table__header-wrapper th.el-table__cell .cell .sort-caret.descending {
    border-top-color: var(--vtm-line-2) !important;
    bottom: 0 !important;
  }

  /* Highlight active sort direction */
  .el-table .el-table__header-wrapper th.el-table__cell.ascending .sort-caret.ascending {
    border-bottom-color: var(--vtm-mint) !important;
  }

  .el-table .el-table__header-wrapper th.el-table__cell.descending .sort-caret.descending {
    border-top-color: var(--vtm-mint) !important;
  }

  /* Force visibility even on hover */
  .el-table .el-table__header-wrapper th.el-table__cell:hover .sort-caret {
    opacity: 1 !important;
    display: block !important;
  }
</style>
